<template>
  <!-- <hm-content title=""> -->
    <div class="add-match-activity-management">
        <template v-if="!$route.query.row || isDetail">
      <div class="mb10" v-if="!isDetail">
          <hm-step
            :steps="steps"
            :step="step"
            :disabledFirst="disabledFirst"
            disabledNext
          ></hm-step>
      </div>
      <div class="step-item-wrap">
        <div class="step-title" v-if="step > 4">
            {{
                stepTitle[step - 1]
            }}
        </div>
      <el-form
        v-show="step === 1"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="110px"
        class="demo-ruleForm"
      >
        <el-form-item label="活动名称" prop="rewardName">
          <el-input
            type="text"
            v-model.trim="ruleForm.rewardName"
            clearable
            style="width: 380px"
            placeholder="请输入活动名称"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="适配商户类型" prop="adapterStoreType">
          <el-radio-group v-model="ruleForm.adapterStoreType">
            <el-radio :label="'norm'">普通商户</el-radio>
            <el-radio :label="'month'">月结商户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动时段" prop="validatorTime" ref="validatorTime">
          <hm-date-select
            title="活动"
            :isShow="isShow"
            :datePicker="datePicker"
            @swithRunningTimeType="swithRunningTimeType"
            ref="hmDateSelect"
            multipleTime
          ></hm-date-select>
        </el-form-item>
        <el-form-item label="活动下线" prop="autoOfflineDaysLimt">
          到期
          <el-input
            type="text"
            maxlength="8"
            @input="filterGt0OrFixed0('autoOfflineDaysLimt')"
            @mousewheel.prevent.native
            style="width: 160px"
            v-model.trim="ruleForm.autoOfflineDaysLimt"
            clearable
            placeholder=""
            size="small"
          ></el-input>
          天，活动下线
        </el-form-item>
      </el-form>
      <div v-show="step === 2">
        <div class="mb10">
          适配组织
          <el-cascader
            clearable
            @change="changgeaa"
            filterable
            style="width: 600px"
            class="mr10 applDepart"
            ref="cascader"
            v-model="ruleForm.applDepartId"
            :props="props"
            :options="cascaderList"
            :show-all-levels="false"
            size="small"
            placeholder="请选择机构"
          ></el-cascader>
        </div>

        <div class="flex flex-between mb10">
          <div>
            <el-button
              type="primary"
              plain
              size="small"
              :disabled="!ruleForm.applDepartId.length"
              @click="merchantDialogVisible = true"
              >+
              {{
                ruleForm.adapterStoreType == "month"
                  ? "添加月结商户"
                  : "添加商户"
              }}
            </el-button>
            <el-input
              v-model="shopSearchVal"
              size="small"
              class="ml10"
              clearable
              placeholder="输入商户名称搜索"
            />
          </div>
          <div>
            <el-button @click="output" type="primary" size="small"
              >导出模板
            </el-button>
            <el-button
              v-if="!ruleForm.applDepartId.length"
              type="info"
              size="small"
              disabled
              >导入表格
            </el-button>
            <el-button
              v-else
              type="primary"
              size="small"
              class="open-file pointer"
              >导入表格
              <input
                type="file"
                class="pointer"
                @change="importfs"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </el-button>
            <span @click="batchRemoveShops" class="pointer ml10">
              <span class="delete-icon hmicon icon-shanchu"></span>批量删除
            </span>
          </div>
        </div>
        <div class="table mb10">
          <el-table
            stripe
            ref="shopRoleTable"
            height="400px"
            :data="
              shopList.filter(
                (data) =>
                  !shopSearchVal ||
                  data.storeName
                    .toLowerCase()
                    .includes(shopSearchVal.toLowerCase())
              )
            "
            style="width: 100%"
            id="table"
            size="small"
            @row-click="
              (row, column, e) => tableSelect(row, column, e, 'shopRoleTable')
            "
            border
            @selection-change="getShopBatchChecked"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="storeName"
              label="商户名称"
            ></el-table-column>

            <el-table-column
              label="操作"
              width="180px"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-tooltip class="item" content="删除" placement="top">
                    <div class="pointer mr10" @click="remove(scope.row)">
                      <span class="hmicon icon-shanchu primary"></span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- <div v-show="step === 3">
        <div class="flex flex-between item-center mb10">
          <div>
            <el-button type="primary" size="small" @click="addGoods"
              >添加商品
            </el-button>
            <el-input
              v-model="goodSearchVal"
              size="small"
              class="ml10"
              clearable
              style="width: 180px"
              placeholder="输入商品名称/条码搜索"
            />
          </div>
          <div class="flex flex-end" style="marginbottom: -20px">
            <div @click="outputExcel" class="delete mr20 pointer">
              <span class="delete-icon hmicon icon-daochu"></span>
              导出模板
            </div>
            <div class="delete mr20 pointer open-file">
              <span class="delete-icon hmicon icon-daoru"></span>
              导入商品
              <input
                type="file"
                @change="importf"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>
            <el-button type="text" size="small" @click="batchRemove"
              >批量删除
            </el-button>
          </div>
        </div>
        <div class="table mb10">
          <el-table
            stripe
            ref="goodRoleTable"
            :data="
              addGoodsList.filter(
                (data) =>
                  !goodSearchVal ||
                  data.goodsName
                    .toLowerCase()
                    .includes(goodSearchVal.toLowerCase()) ||
                  data.goodsBarcode
                    .toLowerCase()
                    .includes(goodSearchVal.toLowerCase())
              )
            "
            style="width: 100%"
            id="table"
            size="small"
            @row-click="
              (row, column, e) => tableSelect(row, column, e, 'goodRoleTable')
            "
            max-height="500px"
            border
            @selection-change="getBatchChecked"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="商品品牌"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsBarcode"
              label="商品条码"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="rewardBaseMoney"
              label="单件奖励"
              v-if="ruleForm.rewardMode === 'sub'"
            >
              <template slot-scope="scope">
                <el-input
                  type="text"
                  maxlength="8"
                  @input="
                    filterGt0OrGoodsListFixed2(scope.$index, 'rewardBaseMoney')
                  "
                  @mousewheel.prevent.native
                  style="width: 100px"
                  v-model.trim="scope.row.rewardBaseMoney"
                  clearable
                  placeholder=""
                  size="small"
                ></el-input>
                元
              </template>
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-tooltip class="item" content="删除" placement="top">
                    <div class="pointer mr10" @click="removeGoods(scope.row)">
                      <span class="hmicon icon-shanchu primary"></span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div> -->
      
      <div v-show="step === 3">
        <div class="step3-wrap mb20">
            
            <div class="content_wrap">
                
                <div class="require">
                    <span class="icon">添加商品组</span>
                    <span>当前分组数量：{{groupList.length}}</span>
                </div>
                <div class="step-item-wrap">
                    <div class="add-btn-wrap" @click="!isDetail ? handleAddGroupList(): ''">
                        <div class="add-icon">+</div>点击添加商品组
                    </div>
                    <div class="add-group">
                        <div class="add-wrap" v-for="(item, index) in groupList" :key="item.id">
                            <div class="header">
                                <span>{{ item.composeName }}</span>
                                <span>限制数量：{{item.goodsUpperLimit}}</span>
                            </div>
                            <el-table :data="item.goodsComposeCollocationInfoModelList" border stripe height="266px" :header-cell-style="{background: '#F7F7F7', color: '#222222', fontSize: '14px'}">
                                <el-table-column label="商品品牌" prop="brandName" align="center"></el-table-column>
                                <el-table-column label="商品名称" prop="goodsName" align="center"></el-table-column>
                                <el-table-column label="商品条码" prop="goodsBarcode" align="center"></el-table-column>
                            </el-table>
                            <div class="footer">
                                <el-button :disabled="isDetail" v-if="(!item.supplierCode && item.id) || $route.query.rewardRuleId" @click="handleAddGroupList(item, 'edit', index)" type="text">+编辑商品</el-button>
                                <el-button @click="handleAddGroupList(item, 'detail', index)" type="text">商品预览</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="step3-wrap">
            <div class="content_wrap">

            <div class="require">
                <span class="icon">设置搭配规则<span title="满足搭配规则可以获得奖励红包" class="tips-icon">?</span></span>
                <!-- <span>当前分组数量：{{2}}</span> -->
            </div>
            <div class="group-wrap">
                <div class="group-item-wrap"  v-for="(item, pInd) in ruleRelModelList" :key="pInd">
                    <!-- 复制 -->
                    <div class="mb20">
                      <el-input style="width: 292px"  v-model="item.ruleName">
                        <template slot="prepend">规则名称</template>
                      </el-input>
                    </div>
                    <div class="group-item">
                    <div class="group-add-item mb20" v-for="(group, cInd) in item.supplierRewardRuleGoodsComposeModelList" :key="cInd">
                        <div v-if="cInd > 0" class="add-icon flex-center">+</div>
                        <el-select style="width: 292px" placeholder="选择商品组" v-model="group.composeName" @change="changeProductGroup($event, pInd, cInd)">
                            <template slot="prefix">商品分组</template>
                            <el-option v-for="(groupItem, ind) in groupList" :key="ind" :disabled="item.supplierRewardRuleGoodsComposeModelList.some(v => v.composeName == groupItem.composeName)" :value="groupItem.composeName" :label="groupItem.composeName+`（限制数量：${groupItem.goodsUpperLimit}）`"></el-option>
                        </el-select>
                        <el-input class="reward" v-model="group.composeAllocateReward" @input="filterInputVal5('ruleRelModelList',pInd,'supplierRewardRuleGoodsComposeModelList',cInd,'composeAllocateReward')" placeholder="请输入">
                          <template slot="prefix">
                              金额￥
                          </template>
                        </el-input>
                        <div v-if="cInd > 1" class="close-item" @click="handleCloseGroup(pInd, cInd)">
                            <span class="hmicon icon-shanchu primary"></span>
                        </div>
                    </div>
                    <div class="add-btn flex-center mb20" @click="handleAddGroup(item, pInd)">+</div>
                    <div class="flex-center  mb20" style="height: 54px;">
                    <div class="equal flex-center">=</div></div>
                    <div class="rewardBaseMoney mb20">
                        <el-input style="width: 292px" placeholder="请输入金额" disabled v-model="item.rewardValue" @input="filterInputVal('ruleRelModelList', pInd, 'rewardValue')">
                            <template slot="prepend">奖励红包</template>
                        </el-input>
                    </div>
                    <div v-if="ruleRelModelList.length > 1" class="add-btn flex-center mb20" @click="handleDeleteGroup(item, pInd)"><span class="hmicon icon-shanchu primary"></span></div>
                </div>
            </div>
            </div>
            <el-button :disabled="isDetail" @click="handleAddMatchRule" class="add-btn" type="text">+增加阶梯搭配规则</el-button>
            </div>
            
        </div>
      </div>
      
      <div v-show="step === 4">
            <div class="step-item-wrap" v-if="step === 4">
                <div class="step-title">活动信息</div>
                <el-form
                    ref="ruleFormEdit"
                    :model="ruleFormEdit"
                    :rules="rulesEdit"
                    label-width="100px"
                >
                <el-form-item label="活动名称:">
                <div
                    class="mr20"
                    style="padding-left: 20px; width: 260px"
                    @dblclick="!isDetail ? changeEnddate():''"
                >
                    <span v-show="edit_enddate">{{ ruleForm.rewardName || row.rewardName }}</span>
                    <el-input
                    :ref="'enddateinput'"
                    @blur="enddateblur()"
                    @keyup.enter.native="$event.target.blur"
                    clearable
                    v-show="!edit_enddate"
                    size="small"
                    style="width: 260px"
                    v-model="ruleForm.rewardName"
                    placeholder="请输入活动名称"
                    ></el-input>
                </div>
                </el-form-item>
                <el-form-item label="活动时间:" prop="autoOfflineDaysLimt">
                    {{ruleForm.rewardStartDate}}至{{ruleForm.rewardEndDate}}
                </el-form-item>
                <el-form-item label="下线规则:" prop="autoOfflineDaysLimt">
                到期
                <span class="blue">{{ruleForm.autoOfflineDaysLimt || ruleFormEdit.autoOfflineDaysLimt}}</span>
                <span> 天后自动下线。</span>
                </el-form-item>
                <el-form-item label="适用商户:" prop="value">
                <div class="mb10">
                    <span
                        class="blue"
                        v-for="(v, i) in shopList"
                        :key="i"
                        >
                        {{ i === 0 ? "" : "," }}{{ v.storeName }}</span
                    >
                    <!-- {{shopList}}
                    <span class="blue">{{storeNames}}</span> -->
                </div>
                </el-form-item>
                <div class="step3-wrap mb20">
            <div class="step-title">适用商品/规则</div>
            <div class="content_wrap">
                
                <div class="require">
                    <span class="icon">添加商品组</span>
                    <span>当前分组数量：{{groupList.length}}</span>
                </div>
                <div class="step-item-wrap">
                    <div class="add-btn-wrap" @click="!isDetail ? handleAddGroupList(): ''">
                        <div class="add-icon">+</div>点击添加商品组
                    </div>
                    <div class="add-group">
                        <div class="add-wrap" v-for="(item, index) in groupList" :key="item.id">
                            <div class="header">
                                <span>{{ item.composeName }}</span>
                                <span>限制数量：{{item.goodsUpperLimit}}</span>
                            </div>
                            <!-- {{item}} -->
                            <!-- {{item.goodsComposeCollocationInfoModelList}} -->
                            <el-table :data="item.goodsComposeCollocationInfoModelList" border stripe height="266px" :header-cell-style="{background: '#F7F7F7', color: '#222222', fontSize: '14px'}">
                                <el-table-column label="商品品牌" prop="brandName" align="center"></el-table-column>
                                <el-table-column label="商品名称" prop="goodsName" align="center"></el-table-column>
                                <el-table-column label="商品条码" prop="goodsBarcode" align="center"></el-table-column>
                            </el-table>
                            <div class="footer">
                                <el-button :disabled="isDetail" @click="handleAddGroupList(item, 'edit', index)" type="text">+编辑商品</el-button>
                                <el-button @click="handleAddGroupList(item, 'detail', index)" type="text">商品预览</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="step3-wrap">
            <div class="content_wrap">

            <div class="require">
                <span class="icon">设置搭配规则<span title="满足搭配规则可以获得奖励红包" class="tips-icon">?</span></span>
            </div>
            <div class="group-wrap">
                <div class="group-item-wrap" v-for="(item, pInd) in ruleRelModelList" :key="pInd">
                    <div class="mb20">
                      <el-input :disabled="!!item.ruleRelId && !$route.query.rewardRuleId" style="width: 292px"  v-model="item.ruleName">
                        <template slot="prepend">规则名称</template>
                      </el-input>
                    </div>
                    <div class="group-item">
                    <div class="group-add-item mb20" v-for="(group, cInd) in item.supplierRewardRuleGoodsComposeModelList" :key="cInd">
                        <div v-if="cInd > 0" class="add-icon flex-center">+</div>
                        <el-select :disabled="!!item.ruleRelId && !$route.query.rewardRuleId" style="width: 292px" placeholder="选择商品组" v-model="group.composeName" @change="changeProductGroup($event, pInd, cInd)">
                            <template slot="prefix">商品分组</template>
                            <el-option v-for="(groupItem, ind) in groupList" :key="ind" :disabled="item.supplierRewardRuleGoodsComposeModelList.some(v => v.composeName == groupItem.composeName)" :value="groupItem.composeName" :label="groupItem.composeName+`（限制数量：${groupItem.goodsUpperLimit}）`"></el-option>
                        </el-select>
                        <el-input class="reward" v-model="group.composeAllocateReward" :disabled="!!item.ruleRelId && !$route.query.rewardRuleId"  @input="filterInputVal5('ruleRelModelList',pInd,'supplierRewardRuleGoodsComposeModelList',cInd,'composeAllocateReward')" placeholder="请输入">
                          <template slot="prefix" >
                              金额￥
                          </template>
                        </el-input>
                        <div v-if="cInd > 1 && !item.ruleRelId" class="close-item" @click="handleCloseGroup(pInd, cInd)">
                            <span class="hmicon icon-shanchu primary"></span>
                        </div>
                    </div>
                    <div v-if="!item.ruleRelId" class="add-btn flex-center mb20" @click="handleAddGroup(item, pInd)">+</div>
                    <div class="flex-center  mb20" style="height: 54px;">
                    <div class="equal flex-center">=</div></div>
                    <div class="rewardBaseMoney mb20">
                        <el-input :disabled="!!item.ruleRelId"  style="width: 292px" placeholder="请输入金额" v-model="item.rewardValue"  @input="filterInputVal('ruleRelModelList', pInd, 'rewardValue')">
                            <template slot="prepend">奖励红包</template>
                        </el-input>
                    </div>
                    <div v-if="!item.ruleRelId && ruleRelModelList.length > 0" class="add-btn flex-center mb20" @click="handleDeleteGroup(item, pInd)"><span class="hmicon icon-shanchu primary"></span></div>
                </div>
            </div>
            </div>
            <el-button :disabled="isDetail" @click="handleAddMatchRule" class="add-btn" type="text">+增加阶梯搭配规则</el-button>
            </div>
        </div>
                </el-form>
            </div>
      </div>
      <div class="btn-wrapper flex flex-center">
        <!-- <el-button size="small" @click="dialogVisible = false">取 消</el-button> -->
        <template v-if="!isDetail">
            <el-button
            size="small"
            type="primary"
            v-if="step > 1"
            @click="step = step - 1"
            >上一步
            </el-button>
            <el-button
            size="small"
            type="primary"
            v-if="step < 3"
            @click="submitRuleForm('ruleForm')"
            >下一步
            </el-button>
            <el-button
            size="small"
            type="primary"
            v-if="step === 3"
            @click="submitRuleForm('ruleForm')"
            >确认/预览
            </el-button>
            <el-button
            size="small"
            type="primary"
            v-if="step === 4"
            @click="submitRuleForm('ruleForm')"
            >保存
            </el-button>
        </template>
        <template v-else>
            <el-button type="success" size="small" v-if="showAudit" @click="handleAudit('pass')">通过</el-button>
            <el-button size="small" v-if="showAudit"
            type="primary" @click="handleAudit('reject')">不通过</el-button>
            <el-button size="small"
            type="primary" @click="handleBack">返回</el-button>
        </template>
      </div>
      </div>
        </template>
        <template v-else>
            <div class="step-item-wrap">
                <el-form
                    ref="ruleFormEdit"
                    :model="ruleFormEdit"
                    :rules="rulesEdit"
                    label-width="100px"
                >
                <el-form-item label="活动名称:">
                <div
                    class="mr20"
                    style="padding-left: 20px; width: 260px"
                    @dblclick="changeEnddate()"
                >
                    <span v-show="edit_enddate">{{ row.rewardName }}</span>
                    <el-input
                    :ref="'enddateinput'"
                    @blur="enddateblur()"
                    @keyup.enter.native="$event.target.blur"
                    clearable
                    v-show="!edit_enddate"
                    size="small"
                    style="width: 260px"
                    v-model="row.rewardName"
                    placeholder="请输入活动名称"
                    ></el-input>
                </div>
                </el-form-item>
                <el-form-item label="活动下线:" prop="autoOfflineDaysLimt">
                到期
                <!-- <el-input-number
                    style="width:220px"
                    v-model="ruleFormEdit.autoOfflineDaysLimt"
                    controls-position="right"
                    :min="numLimt"
                ></el-input-number> -->
                <el-input
                    type="text"
                    maxlength="8"
                    @input="filterGt0OrFixed0('autoOfflineDaysLimt')"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="ruleFormEdit.autoOfflineDaysLimt"
                    clearable
                    placeholder=""
                    size="small"
                ></el-input>
                <span> 天后自动下线。</span>
                <div class="form-item-tip">只能增多天数，不能减少天数</div>
                </el-form-item>
                <el-form-item label="添加商户:" prop="value">
                <div class="mb10">
                    适配组织机构：{{ applDepartNames }}
                    <!-- <el-cascader
                    clearable
                    filterable
                    style="width:600px"
                    class="mr10 applDepart"
                    ref="cascader"
                    v-model="ruleFormEdit.applDepartId"
                    :props="props"
                    :show-all-levels="false"
                    size="small"
                    placeholder="请选择机构"
                    ></el-cascader> -->
                </div>
                <div class="flex flex-between mb10">
                    <div>
                    添加商户：
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        :disabled="!applDepartNames"
                        @click="merchantDialogVisible = true"
                        >+ 添加商户
                    </el-button>
                    </div>
                    <div>
                    <el-button @click="output" type="primary" size="small"
                        >导出模板
                    </el-button>
                    <el-button type="primary" size="small" class="open-file pointer"
                        >导入表格
                        <input
                        type="file"
                        class="pointer"
                        @change="importfs"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        />
                    </el-button>
                    </div>
                </div>
                <div class="table mb10">
                    <el-table
                    stripe
                    ref="roleTable"
                    :data="shopList"
                    style="width: 100%"
                    id="table"
                    size="small"
                    border
                    max-height="400"
                    >
                    <el-table-column type="index" label="序号"></el-table-column>
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="storeName"
                        label="商户名称"
                    ></el-table-column>
                    <!-- <el-table-column
                        header-align="center"
                        align="center"
                        prop="storeName"
                        label="创建时间"
                    ></el-table-column> -->
                    <el-table-column
                        label="操作"
                        header-align="center"
                        align="center"
                    >
                        <template slot-scope="scope">
                        <div class="flex flex-center">
                            <el-tooltip
                            class="item"
                            content="删除"
                            placement="top"
                            v-if="scope.row.delFlag !== '0'"
                            >
                            <div class="pointer mr10" @click="remove(scope.row)">
                                <span class="hmicon icon-shanchu primary"></span>
                            </div>
                            </el-tooltip>
                        </div>
                        </template>
                    </el-table-column>
                    </el-table>
                </div>
                </el-form-item>
                <div class="step3-wrap mb20">
            <div class="step-title">适用商品/规则</div>
            <div class="content_wrap">
                
                <div class="require">
                    <span class="icon">添加商品组</span>
                    <span>当前分组数量：{{groupList.length}}</span>
                </div>
                <div class="step-item-wrap">
                    <div class="add-btn-wrap" @click="handleAddGroupList">
                        <div class="add-icon">+</div>点击添加商品组
                    </div>
                    <div class="add-group">
                        <div class="add-wrap" v-for="(item, index) in groupList" :key="item.id">
                            <div class="header">
                                <span>{{ item.composeName }}</span>
                                <span>限制数量：{{item.goodsUpperLimit}}</span>
                            </div>
                            <!-- {{item}} -->
                            <!-- {{item.goodsComposeCollocationInfoModelList}} -->
                            <el-table :data="item.goodsComposeCollocationInfoModelList" border stripe height="266px" :header-cell-style="{background: '#F7F7F7', color: '#222222', fontSize: '14px'}">
                                <el-table-column label="商品品牌" prop="brandName" align="center"></el-table-column>
                                <el-table-column label="商品名称" prop="goodsName" align="center"></el-table-column>
                                <el-table-column label="商品条码" prop="goodsBarcode" align="center"></el-table-column>
                            </el-table>
                            <div class="footer">
                                <el-button @click="handleAddGroupList(item, 'edit', index)" type="text">+编辑商品</el-button>
                                <el-button @click="handleAddGroupList(item, 'detail', index)" type="text">商品预览</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="step3-wrap">
            <div class="content_wrap">

            <div class="require">
                <span class="icon">设置搭配规则<span title="满足搭配规则可以获得奖励红包" class="tips-icon">?</span></span>
                <!-- <span>当前分组数量：{{2}}</span> -->
            </div>
            <div class="group-wrap">
                <div class="group-item-wrap"  v-for="(item, pInd) in ruleRelModelList" :key="pInd">
                    <!-- 编辑 -->
                    <div class="mb20">
                      <el-input :disabled="!!item.ruleRelId" style="width: 292px"  v-model="item.ruleName">
                        <template slot="prepend">规则名称</template>
                      </el-input>
                    </div>
                    <div class="group-item">
                    <div class="group-add-item mb20" v-for="(group, cInd) in item.supplierRewardRuleGoodsComposeModelList" :key="cInd">
                        <div v-if="cInd > 0" class="add-icon flex-center">+</div>
                        <el-select :disabled="!!item.ruleRelId" style="width: 292px" placeholder="选择商品组" v-model="group.composeName" @change="changeProductGroup($event, pInd, cInd)">
                            <template slot="prefix">商品分组</template>
                            <el-option v-for="(groupItem, ind) in groupList" :key="ind" :disabled="item.supplierRewardRuleGoodsComposeModelList.some(v => v.composeName == groupItem.composeName)" :value="groupItem.composeName" :label="groupItem.composeName+`（限制数量：${groupItem.goodsUpperLimit}）`"></el-option>
                        </el-select>
                        <el-input class="reward" v-model="group.composeAllocateReward" :disabled="!!item.ruleRelId"  @input="filterInputVal5('ruleRelModelList',pInd,'supplierRewardRuleGoodsComposeModelList',cInd,'composeAllocateReward')" placeholder="请输入">
                          <template slot="prefix" >
                              金额￥
                          </template>
                        </el-input>
                        <div v-if="cInd > 1 && !item.ruleRelId" class="close-item" @click="handleCloseGroup(pInd, cInd)">
                            <span class="hmicon icon-shanchu primary"></span>
                        </div>
                    </div>
                    <div v-if="!item.ruleRelId" class="add-btn flex-center mb20" @click="handleAddGroup(item, pInd)">+</div>
                    <div class="flex-center  mb20" style="height: 54px;">
                    <div class="equal flex-center">=</div></div>
                    <div class="rewardBaseMoney mb20">
                        <el-input :disabled="!!item.ruleRelId" style="width: 292px" placeholder="请输入金额" v-model="item.rewardValue" @input="filterInputVal('ruleRelModelList', pInd, 'rewardValue')">
                            <template slot="prepend">奖励红包</template>
                        </el-input>
                    </div>
                    <div v-if="!item.ruleRelId && ruleRelModelList.length > 0" class="add-btn flex-center mb20" @click="handleDeleteGroup(item, pInd)"><span class="hmicon icon-shanchu primary"></span></div>
                </div>
                </div>
            </div>
            <el-button @click="handleAddMatchRule" class="add-btn" type="text">+增加阶梯搭配规则</el-button>
            </div>
        </div>
            <div class="btn-wrapper flex flex-center">
                <el-button
                    size="small"
                    type="primary"
                    @click="submitEdit('ruleFormEdit')"
                    >确 定</el-button
                    >
                <el-button size="small" @click="handleBack">取 消</el-button>
            </div>
        </el-form>
        </div>
        </template>
    <el-dialog
      title="添加商户"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="merchantDialogVisible"
    >
      <div class="form-tip mb20">
        使用<span style="font-weigth: bold; font-size: 16px; color: #e50065"
          >ctrl+f</span
        >
        可搜索商户名
      </div>
      <div class="mb20">
        <el-table
          stripe
          border
          height="400"
          ref="addBrandTable"
          @row-click="
            (row, column, e) => tableSelect(row, column, e, 'addBrandTable')
          "
          @selection-change="getMerchantChecked"
          :data="
            departBindingStoreBox.filter(
              (item) =>
                !merchantName ||
                item.storeName
                  .toLowerCase()
                  .includes(merchantName.toLowerCase())
            )
          "
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商户"
            prop="storeName"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-center">
        <el-button size="small" type="primary" @click="addShop"
          >确 定
        </el-button>
        <el-button size="small" @click="merchantDialogVisible = false"
          >取 消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加商品"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoods"
    >
      <div class="table-panel flex flex-end">
        <div>
          <el-input
            clearable
            style="width: 200px"
            v-model.trim="searchDialogCondition.keyWords"
            placeholder="请输入商品名称/条码"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-select
            clearable
            size="small"
            class="mr10"
            filterable
            v-model="searchDialogCondition.hemiaoBrandId"
            placeholder="请选择商品品牌"
          >
            <el-option
              :label="v.brandName"
              :value="v.hemiaoBrandId"
              v-for="(v, i) in hemiaoBrandBoxList"
              :key="i"
            ></el-option>
          </el-select>

          <el-button type="primary" size="small" @click="searchGoods"
            >查询
          </el-button>
          <el-button size="small" type="text" @click="newGood()"
            >新增商品
          </el-button>
        </div>
      </div>
      <!-- <div class="flex flex-start mb10">
        <div>
          添加商品
          <el-input
            clearable
            style="width:200px;"
            v-model.trim="addGood.goodsName"
            placeholder="请输入商品名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-input
            clearable
            style="width:200px;"
            v-model.trim="addGood.goodsBarcode"
            placeholder="请输入商品条码"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-select
            clearable
            size="small"
            class="mr10"
            v-model="addGood.hemiaoBrandId"
            filterable
            placeholder="请选择商品品牌"
          >
            <el-option
              :label="v.brandName"
              :value="v.hemiaoBrandId"
              v-for="(v, i) in hemiaoBrandBoxList"
              :key="i"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            plain
            size="small"
            :disabled="
              addGood.goodsName === '' ||
                addGood.goodsBarcode === '' ||
                addGood.hemiaoBrandId === ''
            "
            @click="addMerchandise"
            >+ 添加</el-button
          >
        </div>
      </div> -->
      <div class="table">
        <el-table
          stripe
          ref="addGoodTable"
          :data="supplierGoodsInfoList.records"
          @row-click="
            (row, column, e) => tableSelect(row, column, e, 'addGoodTable')
          "
          @selection-change="getChecked"
          style="width: 100%"
          id="table"
          size="small"
          border
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="
              (index) => index + (currentMicroPage - 1) * pageMicroSize + 1
            "
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="商品品牌"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="商品条码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="商品添加时间"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="supplierGoodsInfoList.total"
            @current-change="pagingMicro"
            @size-change="handleSizeMicroChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentMicroPage"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <el-button type="primary" size="small" @click="affirm">确认</el-button>
        <el-button size="small" @click="dialogVisibleGoods = false"
          >取消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="活动详情"
      width="80%"
      :close-on-click-modal="false"
      :visible.sync="detailsDialogVisible"
    >
      <div class="flex flex-between mb10">
        <div class="flex-1">
          活动名称：{{ detailsSupplierBasicInfo.ruleInfo.rewardName }}
        </div>
        <div class="flex-1">
          活动下线：到期<span class="blue">{{
            detailsSupplierBasicInfo.ruleInfo.autoOfflineDaysLimt
          }}</span
          >天后自动下线
        </div>
        <div class="flex-1 flex flex-wrap">
          <div>适用时段：</div>

          <div
            class="flex flex-center blue"
            v-if="
              detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'general'
            "
          >
            {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
              detailsSupplierBasicInfo.ruleInfo.rewardEndDate
            }}
          </div>
          <div
            class="flex flex-center blue"
            v-if="
              detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'special'
            "
          >
            <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'date'">
              {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                detailsSupplierBasicInfo.ruleInfo.rewardEndDate
              }}的每{{ detailsSupplierBasicInfo.ruleInfo.dateValue }}天
            </div>
            <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'week'">
              {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                detailsSupplierBasicInfo.ruleInfo.rewardEndDate
              }}的
              <span
                v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.dateValue"
                :key="i"
              >
                {{ i === 0 ? "" : "," }}每周{{ v }}</span
              >
            </div>
            <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'month'">
              {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                detailsSupplierBasicInfo.ruleInfo.rewardEndDate
              }}的
              <span
                v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.dateValue"
                :key="i"
              >
                {{ i === 0 ? "" : "," }}每月{{ v }}号</span
              >
            </div>
          </div>
        </div>
        <!-- <div class="flex-1">
          基础提成：
          <span
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
            class="primary"
          >
            ¥{{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}</span
          >
          <span v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'">
            {{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}%</span
          >
        </div>
        <div class="flex-1">
          活动条件：参与该活动的商品每满
          <span class="blue">{{
            detailsSupplierBasicInfo.ruleInfo.rewardNumberLimit
          }}</span>
          件为一组计算活动
        </div> -->
      </div>
      <div class="flex flex-between mb10">
        <div class="flex-1">
          适配组织：{{ detailsSupplierBasicInfo.ruleInfo.departNames }}
        </div>
        <div class="flex-1 flex-wrap">
          活动备注：{{ detailsSupplierBasicInfo.ruleInfo.rewardRemark }}
        </div>
      </div>

      <div class="title mb10">
        适用商户:
        <span
          class="blue"
          v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.applyStoreCodes"
          :key="i"
        >
          {{ i === 0 ? "" : "," }}{{ v }}</span
        >
      </div>

      <div class="title mb10">
        适配商户类型：{{
          detailsSupplierBasicInfo.ruleInfo.adapterStoreType == "month"
            ? "月结"
            : "普通"
        }}
      </div>
      <!-- <div class="table mb10">
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.applyStoreCodes"
          style="width: 100%"
          id="table"
          size="small"
          border
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="label"
            label="商户名称"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </div> -->
      <div
        class="title mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
      >
        活动类型：普通活动
      </div>
      <div
        class="title mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
      >
        活动类型：差异活动
      </div>
      <div
        class="title mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
      >
        活动类型：冲刺活动
      </div>
      <div class="title mb10">活动规则：</div>
      <div
        class="table mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
      >
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
          style="width: 500px"
          border
          id="table"
          size="small"
          max-height="500px"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="每组件数"
            prop="rewardNumberLimit"
          >
            <template slot-scope="scope">
              每满{{ scope.row.rewardNumberLimit }}件为一组
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="每组额外奖励"
            prop="rewardValue"
          >
            <template slot-scope="scope">
              {{ scope.row.rewardValue }}元
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="table mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
      >
        <el-table
          :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
          style="width: 100%"
          ref="table"
          stripe
          size="small"
          :show-header="showHeader"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="start"
            label="每组件数"
            width="700"
            prop="rewardNumberLimit"
          >
            <template slot-scope="scope">
              买
              {{ scope.row.rewardNumberLimit }}
              件, 送
              {{ scope.row.rewardSubNum }}
              件,{{
                new Number(scope.row.rewardNumberLimit) +
                new Number(scope.row.rewardSubNum)
              }}件为一组，发放
              {{ scope.row.rewardNumberLimit }}件商品的单件奖励, 每组额外奖励
              {{ scope.row.rewardValue }}
              元
            </template>
          </el-table-column>

          <!-- <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-if="scope.$index === 0"
                      size="small"
                      @click="addChild(scope.$index)"
                      type="text"
                      >新 增</el-button
                    >
                    <el-button
                      v-else
                      size="small"
                      @click="delRule(scope.$index)"
                      class="danger"
                      type="text"
                      >删 除</el-button
                    >
                  </div>
                </template>
              </el-table-column> -->
        </el-table>
      </div>
      <div
        class="table mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
      >
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
          style="width: 500px"
          border
          id="table"
          size="small"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="冲刺门槛"
            prop="rewardNumberLimit"
          >
            <template slot-scope="scope">
              {{ scope.row.rewardNumberLimit }}件
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="额外奖励"
            prop="rewardValue"
          >
            <template slot-scope="scope">
              每件额外奖励{{ scope.row.rewardValue }}元
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="title mb10">适用商品</div>
      <div class="table mb10">
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.goodsList"
          style="width: 100%"
          id="table"
          size="small"
          max-height="500px"
          border
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="商品品牌"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="商品条码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rewardBaseMoney"
            label="单件奖励"
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="detailsDialogVisible = false"
          >确认
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加商品"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGood"
      custom-class="sales-volumn-dialog"
    >
      <el-form
        ref="ruleFormGood"
        :model="ruleFormGood"
        :rules="rulesGood"
        label-width="100px"
      >
        <el-form-item label="商品名称" prop="goodsName">
          <el-input
            clearable
            v-model.trim="ruleFormGood.goodsName"
            maxlength="30"
            size="small"
            placeholder="请输入商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品条码" prop="goodsBarcode">
          <el-input
            clearable
            v-model.trim="ruleFormGood.goodsBarcode"
            maxlength="33"
            size="small"
            placeholder="请输入商品条码"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品品牌" prop="hemiaoBrandId">
          <el-select
            clearable
            size="small"
            class="mr10"
            v-model="ruleFormGood.hemiaoBrandId"
            filterable
            placeholder="请选择商品品牌"
          >
            <el-option
              :label="v.brandName"
              :value="v.hemiaoBrandId"
              v-for="(v, i) in hemiaoBrandBoxList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm('ruleFormGood')"
          >确 定
        </el-button>
        <el-button size="small" @click="dialogVisibleGood = false"
          >取 消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errInputResult.length }}</span
            >条数据导入失败
          </div>
          <!-- <div>
            您有
            <span class="success"> {{ succInputResult.length }}</span
            >条数据导入成功！
          </div> -->
        </div>
        <el-table
          :data="errInputResult"
          border
          class="small-table"
          max-height="400px"
        >
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="错误商品条码"
          >
            <!-- <template slot-scope="scope"
              >{{ scope.row }}
            </template> -->
          </el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号"></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="errValidStore">
      <div slot="title">
        导入失败提示
        <span class="danger"
          >商户名有误、商户名重复或者商户名不属于对应供应商会导致导入失败</span
        >
      </div>
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errStoreResult.length }}</span
            >条数据导入失败
          </div>
          <!-- <div>
            您有
            <span class="success"> {{ succInputResult.length }}</span
            >条数据导入成功！
          </div> -->
        </div>
        <el-table
          :data="errStoreResult"
          border
          class="small-table"
          max-height="500px"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户名称"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      title="操作日志"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleLog"
      custom-class="sales-volumn-dialog"
    >
      <div class="mb10">
        <span class="blue" v-if="row"> {{ row.rewardName }}</span
        >活动
      </div>
      <el-table
        :data="logList"
        style="width: 100%"
        ref="goods"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPageLog - 1) * pageSizeLog + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作人"
          prop="operatorName"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作时间"
          prop="operatorTime"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作行为"
          prop="operatorAction"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.operatorAction === 'yes'">上线</div>
            <div v-if="scope.row.operatorAction === 'no'">下线</div>
            <div v-if="scope.row.operatorAction === 'create'">创建</div>
            <div v-if="scope.row.operatorAction === 'delete'">删除</div>
            <div v-if="scope.row.operatorAction === 'changeDate'">
              修改奖励时段
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalLog"
          @current-change="pagingLog"
          @size-change="handleSizeChangeLog"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPageLog"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      title="修改结束时段"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleTime"
      custom-class="sales-volumn-dialog"
    >
      <div v-if="editTimeShow">
        奖励时段：
        <el-date-picker
          size="small"
          v-model="ruleDate"
          ref="datepicker"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div v-else>
        结束时间：
        <el-date-picker
          v-model="endTime"
          type="date"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          placeholder="结束时间"
          size="small"
          class="mr10"
        >
        </el-date-picker>
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
        <el-button size="small" @click="dialogVisibleTime = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="批量修改结束时段"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleTimeBatch"
      custom-class="sales-volumn-dialog"
    >
      <!-- <div v-if="editTimeShow">
        奖励时段：
        <el-date-picker
          size="small"
          v-model="batchCondition.ruleDate"
          ref="datepicker"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div> -->
      <div>
        结束时间：
        <el-date-picker
          v-model="batchCondition.endTime"
          type="date"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          placeholder="结束时间"
          size="small"
          class="mr10"
        >
        </el-date-picker>
      </div>
      <div class="mt20">
        活动下线: 到期增加<el-input
          type="text"
          maxlength="8"
          @input="filterGt0OrFixed00('addDays')"
          @mousewheel.prevent.native
          style="width: 100px"
          v-model.trim="batchCondition.addDays"
          clearable
          placeholder=""
          size="small"
        ></el-input>
        <span> 天后自动下线。</span>
        <div class="form-item-tip" style="margin-left: 65px">
          只能增多天数，不能减少天数
        </div>
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button size="small" type="primary" @click="batchSetting"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisibleTimeBatch = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="编辑"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :visible.sync="dialogVisibleEdit"
      custom-class="sales-volumn-dialog"
      width="1000px"
    >
      <el-form
        ref="ruleFormEdit"
        :model="ruleFormEdit"
        :rules="rulesEdit"
        label-width="100px"
        v-if="row"
      >
        <el-form-item label="活动名称:">
          <div
            class="mr20"
            style="padding-left: 20px; width: 260px"
            @dblclick="changeEnddate()"
          >
            <span v-show="edit_enddate">{{ row.rewardName }}</span>
            <el-input
              :ref="'enddateinput'"
              @blur="enddateblur()"
              @keyup.enter.native="$event.target.blur"
              clearable
              v-show="!edit_enddate"
              size="small"
              style="width: 260px"
              v-model="row.rewardName"
              placeholder="请输入活动名称"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="活动下线:" prop="autoOfflineDaysLimt">
          到期
          <!-- <el-input-number
            style="width:220px"
            v-model="ruleFormEdit.autoOfflineDaysLimt"
            controls-position="right"
            :min="numLimt"
          ></el-input-number> -->
          <el-input
            type="text"
            maxlength="8"
            @input="filterGt0OrFixed0('autoOfflineDaysLimt')"
            @mousewheel.prevent.native
            style="width: 100px"
            v-model.trim="ruleFormEdit.autoOfflineDaysLimt"
            clearable
            placeholder=""
            size="small"
          ></el-input>
          <span> 天后自动下线。</span>
          <div class="form-item-tip">只能增多天数，不能减少天数</div>
        </el-form-item>
        <el-form-item label="添加商户:" prop="value">
          <div class="mb10">
            适配组织机构：{{ applDepartNames }}
            <!-- <el-cascader
              clearable
              filterable
              style="width:600px"
              class="mr10 applDepart"
              ref="cascader"
              v-model="ruleFormEdit.applDepartId"
              :props="props"
              :show-all-levels="false"
              size="small"
              placeholder="请选择机构"
            ></el-cascader> -->
          </div>
          <div class="flex flex-between mb10">
            <div>
              添加商户：
              <el-button
                type="primary"
                plain
                size="small"
                :disabled="!applDepartNames"
                @click="merchantDialogVisible = true"
                >+ 添加商户
              </el-button>
            </div>
            <div>
              <el-button @click="output" type="primary" size="small"
                >导出模板
              </el-button>
              <el-button type="primary" size="small" class="open-file pointer"
                >导入表格
                <input
                  type="file"
                  class="pointer"
                  @change="importfs"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </el-button>
            </div>
          </div>
          <div class="table mb10">
            <el-table
              stripe
              ref="roleTable"
              :data="shopList"
              style="width: 100%"
              id="table"
              size="small"
              border
              max-height="400"
            >
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="商户名称"
              ></el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="创建时间"
              ></el-table-column> -->
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-tooltip
                      class="item"
                      content="删除"
                      placement="top"
                      v-if="scope.row.delFlag !== '0'"
                    >
                      <div class="pointer mr10" @click="remove(scope.row)">
                        <span class="hmicon icon-shanchu primary"></span>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="添加商品:" prop="">
          <div class="flex flex-between item-center mb10">
            <div>
              <el-button type="primary" plain size="small" @click="editAddGoods"
                >+ 添加商品
              </el-button>
            </div>
            <div class="flex item-center">
              <el-button @click="outputExcel" type="primary" size="small"
                >导出模板
              </el-button>
              <el-button type="primary" size="small" class="open-file pointer"
                >导入表格
                <input
                  type="file"
                  class="pointer"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </el-button>
            </div>
          </div>
          <div class="table mb10">
            <el-table
              stripe
              ref="roleTable"
              :data="addGoodsList"
              style="width: 100%"
              id="table"
              size="small"
              border
              max-height="400"
            >
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="brandName"
                label="商品品牌"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品名称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsBarcode"
                label="商品条码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="rewardBaseMoney"
                label="单件奖励"
                v-if="row.rewardMode === 'sub'"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.delFlag == '0'">{{
                    scope.row.rewardBaseMoney
                  }}</span>
                  <el-input
                    type="text"
                    maxlength="8"
                    @input="
                      filterGt0OrGoodsListFixed2(
                        scope.$index,
                        'rewardBaseMoney'
                      )
                    "
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardBaseMoney"
                    clearable
                    placeholder=""
                    size="small"
                    v-else
                  ></el-input>

                  元
                </template>
              </el-table-column>

              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-tooltip
                      class="item"
                      content="删除"
                      placement="top"
                      v-if="scope.row.delFlag !== '0'"
                    >
                      <div class="pointer mr10" @click="removeGoods(scope.row)">
                        <span class="hmicon icon-shanchu primary"></span>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="submitEdit('ruleFormEdit')"
          >确 定</el-button
        >
        <el-button size="small" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="1000px"
      :close-on-click-modal="false"
      :visible.sync="repeatGoodsDialogVisible"
    >
      <div slot="title">
        提示： <span class="primary"> 以下商品已参与同时段其他活动</span>
      </div>
      <div class="table">
        <el-table
          :data="repeatGoodsList"
          stripe
          border
          size="small"
          class="small-table"
          max-height="500px"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="商品条码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rewardName"
            label="已参加活动名称"
          >
            <template slot-scope="scope">
              <div>
                <el-button
                  v-for="(v, i) in scope.row.repeatRewardInfo"
                  :key="i"
                  type="text"
                  size="small"
                  class="blue"
                  @click="toDetails(v)"
                >
                  {{ v.rewardName }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <!-- <el-button
                  type="text"
                  size="small"
                  @click="toDetails(scope.row)"
                  >活动详情</el-button
                > -->
                <el-button
                  type="text"
                  size="small"
                  @click="importfGoods(scope.row, scope.$index)"
                  >导入
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="flex flex-center">
        <el-button size="small" type="primary" @click="allImportfGoods"
          >全部继续添加
        </el-button>
        <el-button size="small" @click="delectImportfGoods"
          >全部不添加到活动
        </el-button>
        <el-button size="small" @click="repeatGoodsDialogVisible = false"
          >取 消
        </el-button>
      </div>
    </el-dialog>

    <!-- 添加商品组 -->
      <el-dialog
        title='添加商品组'
        :visible.sync='addGroupDialogVisible'
        width='70%'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        destroy-on-close
        custom-class='sales-volumn-dialog common-dialog'
      >
        <!-- <div class='remarks-info'>这里显示备注的信息，这里显示备注的信息</div>
        <template slot='footer'>
          <el-button @click='detailVisible = false' type='primary' size='small'>确定</el-button>
        </template> -->
        <el-form ref="addGroupForm" :model="addGroupForm" label-width="100px">
            <el-form-item v-if="!disabledAddGroup" label="商品组名称" prop="composeName" :rules="[{required: true, message: '请输入商品组名称', trigger: 'blur'}]">
                <el-input v-model.trim="addGroupForm.composeName" placeholder="请输入商品组名称" style="width: 380px;"></el-input>
            </el-form-item>
            <el-form-item v-if="!disabledAddGroup" label="限制数量" prop="goodsUpperLimit" :rules="[{required: true, message: '请输入限制数量', trigger: 'blur'}]">
                <el-input v-model.trim="addGroupForm.goodsUpperLimit" @input="filterInputVal2('addGroupForm','goodsUpperLimit')"
            @mousewheel.prevent.native placeholder="请输入限制数量" style="width: 380px;"></el-input>
            </el-form-item>
            <div class="search-wrap mb20">
                <div class="left">
                    <el-input
                        clearable
                        style="width: 200px"
                        v-model.trim="searchDialogCondition.keyWords"
                        placeholder="请输入商品名称/商品条码"
                        size="small"
                        class="ipt mr10"
                    ></el-input>
                    <el-select
                        clearable
                        size="small"
                        class="mr10"
                        filterable
                        v-model="searchDialogCondition.hemiaoBrandId"
                        placeholder="请选择商品品牌"
                    >
                        <el-option
                        :label="v.brandName"
                        :value="v.hemiaoBrandId"
                        v-for="(v, i) in hemiaoBrandBoxList"
                        :key="i"
                        ></el-option>
                    </el-select>
                    <el-button type="primary" size="small" @click="searchGoods">查询</el-button>
                </div>
                <div class="right">
                    <!-- <div class="import" @click="addProductVisible = true">
                        <span class="delete-icon hmicon icon-daoru"></span>
                        导入商品模板
                        <input
                            type="file"
                            @change="importf"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        />
                    </div> -->
                    
                    <!-- <div class="export" @click="output">
                        <span class="delete-icon hmicon icon-daochu"></span>
                        导出商品模板
                    </div> -->
                    <!-- <div @click="outputExcel" class="delete mr20 pointer">
                        <span class="delete-icon hmicon icon-daochu"></span>
                        导出商品模板
                        </div>
                        <div class="delete mr20 pointer open-file">
                        <span class="delete-icon hmicon icon-daoru"></span>
                        导入商品模板
                        <input
                            type="file"
                            @change="importf"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        />
                    </div> -->
                    <div @click="outputExcel" class="delete mr20 pointer">
                        <span class="delete-icon hmicon icon-daochu"></span>
                        导出模板
                        </div>
                        <div class="delete mr20 pointer open-file" @click.stop="''">
                        <span class="delete-icon hmicon icon-daoru"></span>
                        导入商品
                        <input
                            type="file"
                            @change="importf"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        />
                        </div>
                </div>
            </div>
            <!-- <el-table :data="supplierGoodsInfoList.records" stripe border style="width: 100%" empty-text="暂无商品数据">
                <el-table-column type="selection"></el-table-column>
                <el-table-column width="80px" type="index" label="序号"></el-table-column>
                <el-table-column label="商品品牌"></el-table-column>
                <el-table-column label="商品名称"></el-table-column>
                <el-table-column label="商品条码"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="{row}=scope">
                        <el-button type="text" @click="handleDelProduct(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table> -->
            <el-table
                stripe
                ref="addGoodGroupTable"
                :data="supplierGoodsInfoList.records"
                @row-click="
                    (row, column, e) => tableSelect(row, column, e, 'addGoodGroupTable')
                "
                @selection-change="getChecked"
                style="width: 100%"
                id="table"
                size="small"
                border
                >
                <el-table-column type="selection"></el-table-column>
                <el-table-column
                    type="index"
                    label="序号"
                    header-align="center"
                    align="center"
                    :index="
                    (index) => index + (currentMicroPage - 1) * pageMicroSize + 1
                    "
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="brandName"
                    label="商品品牌"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsName"
                    label="商品名称"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsBarcode"
                    label="商品条码"
                ></el-table-column>
                <!-- <el-table-column label="操作">
                    <template slot-scope="{row}=scope">
                        <el-button type="text" @click="handleDelProduct(row)">删除</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <!-- <div2 class="hm-pagination">
            <el-pagination
                background
                :total="supplierGoodsInfoList.total"
                @current-change="pagingMicro($event, 'addGoodGroupTable')"
                @size-change="handleSizeMicroChange"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentMicroPage"
            ></el-pagination>
            </div2> -->
            <el-row class="page-wrap mt20 ">
                <!-- <el-button size="mini" @click="batchRemoveShops" class="pointer ml10 delete-some">
                    <span class="delete-icon hmicon icon-shanchu"></span>批量删除
                </el-button> -->
                <el-pagination
                    background
                    :total="supplierGoodsInfoList.total"
                    @current-change="pagingMicro($event, 'addGoodGroupTable')"
                    @size-change="handleSizeMicroChange"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="currentMicroPage"
                ></el-pagination>
            </el-row>
        </el-form>
        <!-- <el-row class="page-wrap mt20 ">
            <el-button size="mini" @click="batchRemoveShops" class="pointer ml10 delete-some">
                <span class="delete-icon hmicon icon-shanchu"></span>批量删除
            </el-button>
            <el-pagination
                background
                :total="totalLog"
                @current-change="pagingLog"
                @size-change="handleSizeChangeLog"
                layout="total,  prev, pager, next, jumper,sizes"
                :current-page="currentPageLog"
            ></el-pagination>
        </el-row> -->
        <el-row class="dialog-btn mt20" type="flex" justify="center">
            <el-button @click="handleAddGroupSubmit" size="small" type="primary">确认</el-button>
            <el-button @click="addGroupDialogVisible = false" size="small" type="info">取消</el-button>
        </el-row>
    </el-dialog>
<!-- 添加商品 -->
        <el-dialog
          title='添加商品'
          :visible.sync='addProductVisible'
          width='60%'
          :close-on-click-modal='false'
          :close-on-press-escape='false'
          destroy-on-close
          custom-class='common-dialog'
        >
            <el-table ref="addProductTable" :data="finalTable" @selection-change="batchDelProductsChange"> class="mb10" stripe border style="width: 100%" empty-text="暂无商品数据">
                <el-table-column type="selection" v-if="!forbidden"></el-table-column>
                <el-table-column width="80px" type="index" label="序号"></el-table-column>
                <el-table-column label="商品品牌" prop="brandName"></el-table-column>
                <el-table-column label="商品名称" prop="goodsName"></el-table-column>
                <el-table-column label="商品条码" prop="goodsBarcode"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="!forbidden" type="text" @click="handleDelProduct(scope)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row class="page-wrap mt20 ">
                <el-button v-if="!forbidden" size="mini" @click="batchDelProducts" class="pointer delete-some">
                    <span class="delete-icon hmicon icon-shanchu"></span>批量删除
                </el-button>
                <el-pagination
                    background
                    :total="initTableList.length"
                    @current-change="changeAddProductPage"
                    @size-change="changeAddProductSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="addProductPage"
                ></el-pagination>
            </el-row>
            <el-row class="dialog-btn mt5" type="flex" justify="center">
                <el-button @click="showConfirmBox" size="small" type="primary">确认</el-button>
                <el-button @click="addProductVisible = false" size="small" type="info">取消</el-button>
            </el-row>
        </el-dialog>
    </div>
  <!-- </hm-content> -->
</template>

<script>
import moment from "moment";
import HmStep from "@/components/HmStep";
import HmDateSelect from "@/components/HmDateSelect";
import { mapGetters } from "vuex";
import {
  arrayUnique2,
  isRepeat,
  compareDate,
  getSubtract,
  getRemove,
  setCookie,
  getCookie,
} from "@/utils/utils";
// import XLSX from "xlsx";
import * as XLSX from "xlsx/xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: { HmStep, HmDateSelect },
  data() {
    const autoOfflineDaysLimtFunc = (rule, val, callback) => {
      if (new Number(val) < new Number(this.numLimt)) {
        return callback(new Error("到期天数不能小于" + this.numLimt + "天"));
      }
      callback();
    };
    const validatorRewardFunc = (rule, val, callback) => {
      if (this.ruleForm.rewardMode === "sub") {
        if (val.length > 0) {
          let flag = false;
          val.forEach((v) => {
            if (v.rewardNumberLimit === "" || v.rewardValue === "") {
              flag = true;
            }
          });
          if (flag) {
            return callback(new Error("请填写完整规则！"));
          }
        }
      } else {
        if (val.length === 0) {
          return callback(new Error("请添加活动规则"));
        } else {
          let flag = false;
          val.forEach((v) => {
            if (v.rewardNumberLimit === "" || v.rewardValue === "") {
              flag = true;
            }
          });
          if (flag) {
            return callback(new Error("请填写完整规则！"));
          }
          let ary = val.map((o) => o.rewardNumberLimit);
          if (isRepeat(ary)) {
            return callback(new Error("相同件数不允许重复！"));
          }
        }
      }

      callback();
    };
    const validatorFunc = (rule, val, callback) => {
      const {
        runningTimeType,
        ruleDateAndTime,
        ruleDate,
        dateType,
        dateValue,
        dateConfigRange,
        week,
        daysList,
      } = this.$refs.hmDateSelect;
      // 选择全时段
      if (runningTimeType === "all") {
        if ((ruleDateAndTime && !ruleDateAndTime[0]) || !ruleDateAndTime) {
          return callback(new Error("请选择日期"));
        }
        callback();
        // 选择特定时段
      } else if (runningTimeType === "special") {
        if (dateConfigRange && !dateConfigRange.length) {
          return callback(new Error("请选择促销时间"));
        } else if ((ruleDate && !ruleDate.length) || !ruleDate) {
          return callback(new Error("请选择促销日期"));
        }
        if (dateType === "day") {
          if (!dateValue) {
            return callback(new Error("请输入促销天数"));
          } else callback();
        } else if (dateType === "week") {
          if (week && !week.length) {
            return callback(new Error("请选择促销周"));
          }
          callback();
        } else if (dateType === "month") {
          if (daysList && !daysList.length) {
            return callback(new Error("请选择促销天"));
          }
          callback();
        }
      }
    };
    // const typeFunc = function(rule, val, callback) {
    //   if (val === "fixed") {
    //     if (this.ruleForm.rewardValue === "") {
    //       return callback(new Error("请输入缴费金额"));
    //     }
    //   } else if (val === "radio") {
    //     if (this.ruleForm.rewardValue === "") {
    //       return callback(new Error("请输入缴费比例"));
    //     } else {
    //       if (this.ruleForm.rewardValue > 100) {
    //         return callback(new Error("缴费比例不能超过100%"));
    //       }
    //     }
    //   }

    //   callback();
    // }.bind(this);
    return {
      repeatGoodsList: [],
      repeatGoodsDialogVisible: false,
      errValidStore: false,
      errStoreResult: [],
      checkedRowList: [],
      checkedMerchantRow: [],
      numLimt: 0,
      ruleFormEdit: {
        autoOfflineDaysLimt: "",
        applDepartId: [],
      },
      rulesEdit: {
        autoOfflineDaysLimt: [
          {
            required: true,
            message: "请输入到期天数",
            trigger: "change",
          },
          {
            required: true,
            pattern: /^([1-9]\d*|[0]{1,1})$/,
            message: "请输入正整数",
            trigger: "change",
          },
          {
            required: true,
            validator: autoOfflineDaysLimtFunc,
            trigger: "blur",
          },
        ],
      },
      dialogVisibleEdit: false,
      ruleDate: [],
      showHeader: false,
      dialogVisibleTime: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < moment().subtract(1, "days");
        },
      },
      endTime: "",
      currentPageLog: 1,
      pageSizeLog: 10,
      totalLog: 0,
      dialogVisibleLog: false,
      //   ruleRelModelList: [],
      succInputResult: [],
      errInputResult: [],
      errValidGoods: false,
      dialogVisibleGood: false,
      ruleFormGood: {
        goodsName: "",
        goodsBarcode: "",
        hemiaoBrandId: "",
      },
      rulesGood: {
        goodsName: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
          {
            required: true,
            max: 30,
            message: "名称应大于30个字",
            trigger: "blur",
          },
        ],
        goodsBarcode: [
          {
            required: true,
            message: "请输入商品条码",
            trigger: "blur",
          },
        ],
        hemiaoBrandId: [
          {
            required: true,
            message: "请选择商品品牌",
            trigger: "blur",
          },
        ],
      },
      detailsDialogVisible: false,
      cascaderList: [],
      isShow: false,
      datePicker: true,
      props: {
        lazy: false,
        multiple: true,
        // checkStrictly: true,
        // lazyLoad: (node, resolve) => {
        //   const { level, data } = node;
        //   if (level === 0) {
        //     this.$store
        //       .dispatch("queryOrganizationList", {
        //         pageNo: 1,
        //         pageSize: 999,
        //         loginType: "supplier",
        //         storeCode: this.$route.query.storeCode,
        //       })
        //       .then((res) => {
        //         res.result.records.forEach((v) => {
        //           v.leaf = Boolean(!v.isParent);
        //           v.all = {
        //             label: v.departName,
        //             value: v.id || v.treeStruct,
        //           };
        //           v.value = v.all;
        //           v.label = v.departName;
        //         });
        //         console.log('node', node);
        //         resolve(res.result.records);
        //       });
        //   } else {
        //     this.$store
        //       .dispatch("queryListOrganizationListByParent", {
        //         parentId: data.treeStruct,
        //         loginType: "supplier",
        //         storeCode: this.$route.query.storeCode,
        //       })
        //       .then((res) => {
        //         if (res.code === "0" && res.result) {
        //           res.result.forEach((v) => {
        //             v.leaf = Boolean(!v.isParent);
        //             // v.value = v.id;
        //             // v.label = v.departName;
        //             v.all = {
        //               label: v.departName,
        //               value: v.id || v.treeStruct,
        //             };
        //             v.value = v.all;
        //             v.label = v.departName;
        //           });
        //           resolve(res.result);
        //         } else {
        //           resolve([]);
        //         }
        //       });
          // }
        // },
      },
      searchCondition: {
        applyDepartIds: [],
        queryType: "goodsName",
      },
      currentPage: 1,
      pageSize: 10,
      storeNames: "",
      addGoodsList: [],
      holdeCheckedMerchantRow: [],
      currentMicroPage: 1,
      pageMicroSize: 10,
      checkedRow: [],
      checkedDelRow: [],
      dialogVisibleGoods: false,
      searchDialogCondition: {},
      addGood: {
        goodsName: "",
        goodsBarcode: "",
        hemiaoBrandId: "",
        storeCode: this.$route.query.storeCode,
      },
      shopList: [],
      options: [],
      value: "",
      list: [],
      loading: false,
      states: [],
      dialogVisible: false,
      merchantDialogVisible: false,
      step: 1,
      merchantName: "",
      disabledFirst: false,
      ruleForm: {
        rewardName: "",
        rewardNumberLimit: "",
        rewardMode: "collocation",
        rewardValue: "",
        applDepartId: [],
        rewardRemark: "",
        autoOfflineDaysLimt: "",
        rewardStartDate: "",
        rewardEndDate: "",
        ruleRelModelList: [
          {
            rewardNumberLimit: "",
            rewardValue: "",
          },
        ],
        adapterStoreType: "norm",
      },
      rules: {
        validatorTime: {
          required: true,
          validator: validatorFunc,
          trigger: "blur",
        },
        rewardName: {
          required: true,
          message: "请输入活动名称",
          trigger: "change",
        },
        ruleRelModelList: [
          {
            required: true,
            validator: validatorRewardFunc,
            trigger: "blur",
          },
        ],
        rewardMode: [
          {
            required: true,
            message: "请选择缴费方式",
            trigger: "blur",
          },
          // {
          //   required: true,
          //   validator: typeFunc,
          //   trigger: "blur"
          // }
        ],
        applDepartId: [
          {
            required: true,
            message: "请选择匹配组织架构",
            trigger: "blur",
          },
        ],
        autoOfflineDaysLimt: {
          required: true,
          message: "请输入活动下线时间",
          trigger: "change",
        },
        adapterStoreType: {
          required: true,
          message: "请选择适配商户类型",
          trigger: "change",
        },
      },
      steps: [
        {
          name: "活动规则",
        },
        {
          name: "适用商户",
        },
        {
          name: "适用商品",
        },
        {
          name: "创建活动",
        },
      ],
      type: "",
      flag: false,
      row: {},
      logList: [],
      editTimeShow: false,
      autoOfflineDaysLimt: "",
      applDepartNames: "",
      checkedShopRowList: [],
      shopSearchVal: "",
      goodSearchVal: "",
      edit_enddate: true,
      editwxName: "",
      selectActivityIndex: null,
      storeBasicInfoListBoxList: [],
      batchCondition: {
        ruleDate: "",
        endTime: "",
      },
      dialogVisibleTimeBatch: false,
      edit_rewardName: true,
      editrewardName: "",
      stepTitle: ["活动信息", "适用商户", "适用商品/规则"],
      matchRules: [
        {
          ruleGoodsList: [{ seqNum: 0 }, { seqNum: 1 }],
          rewardBaseMoney: "",
        },
      ],
      ruleRelModelList: [
        {
          rewardValue: "", // 奖励值
          seqNum: 0,
          supplierRewardRuleGoodsComposeModelList: [
            {
              composeName: "",
              goodsUpperLimit: "",
              seqNum: 0,
              ruleGoodsList: [],
            },
            {
              composeName: "",
              goodsUpperLimit: "",
              seqNum: 1,
              ruleGoodsList: [],
            },
          ],
        },
      ],
      addGroupDialogVisible: false,
      addGroupForm: {
        composeName: "", //  商品组名称
        goodsUpperLimit: "", // 限制数量
      },
      addProductVisible: false,
      checkedList: {},
      groupList: [],
      disabledAddGroup: false,
      currentListIndex: 0,
      initTableList: [],
      row: null,
      disabledEdit: false,
      editInd: null,
      forbidden: false,
      isDetail: false,
      showAudit: false,
      addProductPage: 1,
      addProductSize: 10,
    };
  },
  computed: {
    ...mapGetters([
      "supplierRewardRuleInfoList",
      "storeBasicInfoListBox",
      "departBindingStoreBox",
      "supplierGoodsInfoList",
      "hemiaoBrandBoxList",
      "detailsSupplierBasicInfo",
    ]),
    finalTable() {
      console.log(this.initTableList,9999999999)
      return this.initTableList.slice(
        (this.addProductPage - 1) * this.addProductSize,
        this.addProductPage * this.addProductSize
      );
    },
  },
  watch: {},
  created() {
    if (this.$route.query.rewardRuleId) {
      this.copy(this.$route.query.rewardRuleId);
    } else {
      let row = this.$route.query.row;
      this.initCategory()
      this.isDetail =
        this.$route.query.type && this.$route.query.type == "detail";
      console.log(this.isDetail);
      this.isDetail = !!this.isDetail;
      this.showAudit = !!this.$route.query.showAudit;
      if (this.isDetail) {
        this.step = 4;
      }
      if (row) {
        this.ruleForm.rewardName = row.rewardName;
        this.row = JSON.parse(row);
        this.getDetail(this.row);
        this.disabledEdit = true;
      }
    }
  },
  mounted() {
    this.storeNames = localStorage.getItem("storeName");
    this.getParamsCookie();
    this.queryList();
    this.$store.dispatch("queryStoreBasicInfoListBox", {
      supplierCode: this.$route.query.storeCode,
    });
  },
  methods: {
    initCategory() {
       this.$store
          .dispatch("queryPageDepartInfoList", {
            pageNo: 1,
            pageSize: 999,
            loginType: "supplier",
            storeCode: this.$route.query.storeCode,
          })
          .then((res) => {
            console.log('---initCategory---', res);
            const list = res.result.records.map(v => {
                  v.all = {
                    label: v.departName,
                    value: v.id || v.treeStruct,
                  };
                  v.value = v.all;
                  v.label = v.departName;
                  this.deepDeal(v)
                  return v
            })
            console.log('---list---', list);
            this.cascaderList = list
          });
    },
    deepDeal(v) {
      if(v.children && v.children.length) {
        v.children.map(item => {
          item.all = {
          label: item.departName,
          value: item.id || item.treeStruct,
        };
        item.value = item.all;
        item.label = item.departName;
        this.deepDeal(item)
        return item
        }
        )
      } else {
        v.children = null
      }
    },
    changeAddProductPage(val) {
      console.log(val);
      this.addProductPage = val;
    },
    changeAddProductSize(val) {
      console.log(val);
      this.addProductSize = val;
    },
    /**
     * @desc 是否可选
     */
    isSelectAble(row) {
      return !this.forbidden && row.hemiaoGoodsId;
    },
    async copy(rewardRuleId) {
      this.type = "copy";
      // this.dialogVisible = true;
      const { result } = await this.$store.dispatch(
        "copySupplierRewardRuleInfo",
        {
          rewardRuleId,
        }
      );
      console.log("resultresultresult---copy:", result);

      for (let key in this.ruleForm) {
        if (key !== "applDepartIds") {
          this.ruleForm[key] = result[key];
        }
      }
      this.ruleForm.applyDepartIds = [];
      this.ruleForm.applyDepartNames = [];
      this.ruleForm.applDepartId = result.storeDepartInfoModelList;
      result.storeDepartInfoModelList.forEach((v) => {
        this.ruleForm.applyDepartIds.push(v.id);
        this.ruleForm.applyDepartNames.push(v.departName);
      });
      this.addGoodsList = result.ruleGoodsList;
      this.shopList = result.storeBasicInfoModelList;
      const data = await this.$store.dispatch(
        "findSupplierRewardRuleInfoCollocationList",
        {
          rewardRuleId: rewardRuleId,
          supplierCode: this.$route.query.storeCode,
        }
      );
      console.log("----data-----", data);
      if (data && data.code == "0") {
        this.ruleRelModelList = data.result.rewardRuleRelModelList.map(
          (item) => {
            item.seqNum = item.ruleSeqNum;
            item.supplierRewardRuleGoodsComposeModelList = item.rewardRuleRelModelComposeModel.map(
              (v) => {
                let list = data.result.rewardRuleGoodsComposeModelList.find(
                  (li) => li.composeId == v.composeId
                );
                v.goodsUpperLimit = list ? list.goodsUpperLimit : "";
                v.seqNum = v.composeSeqNum;
                v.ruleGoodsList = list
                  ? list.goodsComposeCollocationInfoModelList
                  : [];
                return v;
              }
            );
            return item;
          }
          //   rewardRuleGoodsComposeModelList
        );
        console.log("---ruleRelModelList---: ", this.ruleRelModelList);
        this.groupList = data.result.rewardRuleGoodsComposeModelList;
        // .map(
        //   (item) => {
        //     let list = item.goodsComposeCollocationInfoModelList.map((v) => {
        //       return {
        //         brandName: v.brandName,
        //         goodsName: v.goodsName,
        //         goodsBarcode: v.goodsBarcode,
        //       };
        //     });
        //     item.goodsComposeCollocationInfoModelList = list;
        //     return item;
        //   }
        // );
      }
      setTimeout(() => {
        if (this.$refs.cascader) {
          this.$refs.cascader.presentText = result.storeDepartInfoModelList
            .map((o) => o.departName)
            .join(",");
        }
        this.$refs.hmDateSelect.runningTimeType =
          result.dateConfigMode === "general" ? "all" : "special";

        if (this.$refs.hmDateSelect.runningTimeType === "all") {
          // 选择全时段

          this.$refs.hmDateSelect.ruleDateAndTime = [
            `${result.rewardStartDate} 00:00:00`,
            `${result.rewardEndDate} 23:59:59`,
          ];
        } else if (this.$refs.hmDateSelect.runningTimeType === "special") {
          // 选择特定时段
          // step1.dateConfigRange = dateConfigRange.sort(
          //   this.sortTime("promotionStartTime")
          // );
          this.$refs.hmDateSelect.ruleDate = [
            result.rewardStartDate,
            result.rewardEndDate,
          ];
          // step1.rewardStartDate = ruleDate[0];
          // step1.rewardEndDate = ruleDate[1];
          this.$refs.hmDateSelect.dateType =
            result.dateType === "day" ? "date" : result.dateType;

          // step1.dateType = dateType === "day" ? "date" : dateType;
          // if (this.$refs.hmDateSelect.dateType === "day") {
          //   step1.dateValue = dateValue.sort();
          // } else if (this.$refs.hmDateSelect.dateType === "week") {
          //   step1.dateValue = week.sort();
          // } else if (this.$refs.hmDateSelect.dateType === "month") {
          //   step1.dateValue = daysList;
          // }
        }
        // this.supplierGoodsInfoCheckGoods(result.ruleGoodsList);
      }, 0);
      // setTimeout(() => {
      // }, 200);
    },
    async getDetail(row) {
      //   this.selectActivityIndex = index;
      console.log(row);
      const { result } = await this.$store.dispatch(
        "copySupplierRewardRuleInfo",
        {
          rewardRuleId: row.rewardRuleId,
        }
      );
      this.ruleForm.applyDepartIds = [];
      this.ruleForm.rewardStartDate = result.rewardStartDate;
      this.ruleForm.rewardEndDate = result.rewardEndDate;
      this.ruleForm.rewardMode = result.rewardMode;
      result.storeDepartInfoModelList.forEach((v) => {
        this.ruleForm.applyDepartIds.push(v.id);
        // this.ruleForm.applyDepartNames.push(v.departName);
      });
      this.applDepartNames = result.storeDepartInfoModelList
        .map((o) => o.departName)
        .join(",");
      this.shopList = result.storeBasicInfoModelList;
      this.addGoodsList = result.ruleGoodsList;
      this.ruleFormEdit.autoOfflineDaysLimt = JSON.stringify(
        JSON.parse(result.autoOfflineDaysLimt)
      );
      this.numLimt = JSON.stringify(JSON.parse(result.autoOfflineDaysLimt));
      const data = await this.$store.dispatch(
        "findSupplierRewardRuleInfoCollocationList",
        {
          rewardRuleId: row.rewardRuleId,
          supplierCode: this.$route.query.storeCode,
        }
      );
      console.log("----data-----", data);
      if (data && data.code == "0") {
        this.ruleRelModelList = data.result.rewardRuleRelModelList.map(
          (item) => {
            item.supplierRewardRuleGoodsComposeModelList =
              item.rewardRuleRelModelComposeModel;
            return item;
          }
        );
        this.groupList = data.result.rewardRuleGoodsComposeModelList;
        // .map(
        // (item) => {
        // let list = item.goodsComposeCollocationInfoModelList.map((v) => {
        //   return {
        //     brandName: v.brandName,
        //     goodsName: v.goodsName,
        //     goodsBarcode: v.goodsBarcode,
        //   };
        // });
        // item.goodsComposeCollocationInfoModelList = list;
        // return item;
        // }
        // );
        console.log("---this.groupList--", this.groupList);
      }
      console.log("---this.ruleRelModelList ---", this.ruleRelModelList);
      this.queryStoreBoxList();
      this.$forceUpdate();
    },
    showConfirmBox() {
      if (this.forbidden) {
        this.addProductVisible = false;
        return;
      }
      if (!this.initTableList || !this.initTableList.length) {
        return this.$message.warning("商品组内至少添加一个商品");
      }
      console.log("---groupList--", this.groupList);
      console.log("--this.initTableList--", this.initTableList);
      if (this.editInd !== null) {
        console.log(
          "--this.goodsComposeCollocationInfoModelList[this.editInd]--",
          this.groupList[this.editInd].goodsComposeCollocationInfoModelList
        );
        for (let item of this.initTableList) {
          console.log("initTableList---item", item);
          for (let [index, g] of this.groupList.entries()) {
            console.log(index, g);
            // 遍历查找是所有组里否有该商品
            const find = g.goodsComposeCollocationInfoModelList.find(
              (v) =>
                (v.goodsBarcode == item.goodsBarcode ||
                  v.goodsSn == item.goodsSn) &&
                v.goodsName == item.goodsName
            );
            // const findIndex = g.goodsComposeCollocationInfoModelList.findIndex(
            //   (v) =>
            //     (v.goodsBarcode == item.goodsBarcode ||
            //       v.goodsSn == item.goodsSn) &&
            //     v.goodsName == item.goodsName
            // );
            // console.log("---findIndex---", findIndex);
            console.log("---find---", find);
            if (find && this.editInd !== index) {
              return this.$message.warning(
                `商品${find.goodsName}在${g.composeName}组已存在`
              );
            }
          }
        }
        this.groupList[
          this.editInd
        ].goodsComposeCollocationInfoModelList = this.initTableList;
      } else {
        const index = this.groupList.findIndex(
          (item) => item.composeName == this.addGroupForm.composeName
        );
        if (index > -1) {
          this.$message.warning("商品组名称不能重复");
          return;
        }
        for (let item of this.initTableList) {
          console.log("initTableList---item", item);
          for (let g of this.groupList) {
            const find = g.goodsComposeCollocationInfoModelList.find(
              (v) =>
                (v.goodsBarcode == item.goodsBarcode ||
                  v.goodsSn == item.goodsSn) &&
                v.goodsName == item.goodsName
            );
            if (find) {
              return this.$message.warning(
                `商品${find.goodsName}在${g.composeName}组已存在`
              );
            }
          }
        }

        this.groupList.push({
          ...this.addGroupForm,
          goodsComposeCollocationInfoModelList: this.initTableList,
          id: new Date().getTime(),
        });
      }
      this.addGroupForm = {
        composeName: "",
        goodsUpperLimit: "",
      };

      this.searchDialogCondition = {
        keyWords: "",
        hemiaoBrandId: "",
      };
      this.searchGoods();
      this.addGroupDialogVisible = false;
      this.addProductVisible = false;
      //   const h = this.$createElement;
      //   this.$msgbox({
      //     //   title: '消息',
      //     message: h("p", null, [
      //       h("span", null, "内容可以是 "),
      //       h("i", { style: "color: teal" }, "VNode"),
      //     ]),
      //     showCancelButton: true,
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     beforeClose: (action, instance, done) => {
      //       if (action === "confirm") {
      //         instance.confirmButtonLoading = true;
      //         instance.confirmButtonText = "执行中...";
      //         setTimeout(() => {
      //           done();
      //           this.groupList[this.currentListIndex].goodsComposeCollocationInfoModelList = JSON.parse(
      //             JSON.stringify(this.initTableList)
      //           );
      //           setTimeout(() => {
      //             instance.confirmButtonLoading = false;
      //           }, 300);
      //         }, 500);
      //       } else {
      //         done();
      //       }
      //     },
      //   }).then((action) => {
      //     this.$message({
      //       type: "info",
      //       message: "action: " + action,
      //     });
      //   });
    },
    changeEnddate() {
      this.editwxName = this.row
        ? this.row.rewardName
        : this.ruleForm.rewardName;
      this.edit_enddate = !this.edit_enddate; //直接加key
      // this.list = [...this.list];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs.enddateinput.focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    enddateblur() {
      let rewardName = this.row
        ? this.row.rewardName
        : this.ruleForm.rewardName;
      if (rewardName === "" || rewardName === this.editwxName) {
        this.row.rewardName = this.editwxName;
      }
      this.edit_enddate = !this.edit_enddate;
    },
    changeRewardName() {
      this.editrewardName = this.ruleForm.rewardName;
      this.edit_rewardName = !this.edit_rewardName; //直接加key
      // this.list = [...this.list];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs.rewardNameinput.focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    rewardNameblur() {
      if (
        this.ruleForm.rewardName === "" ||
        this.ruleForm.rewardName === this.editrewardName
      ) {
        this.ruleForm.rewardName = this.editrewardName;
      }
      this.edit_rewardName = !this.edit_rewardName;
    },
    tableSelect(row, column, event, tableName) {
      if (column.label != "操作" && column.label != "单件奖励") {
        this.$refs[tableName].toggleRowSelection(row);
      }
    },
    getShopBatchChecked(selection) {
      this.checkedShopRowList = selection;
    },
    batchRemoveShops() {
      if (this.checkedShopRowList.length) {
        this.shopList = getSubtract(
          this.shopList,
          this.checkedShopRowList,
          "storeCode"
        );
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    batchRemove() {
      if (this.checkedRowList.length) {
        this.addGoodsList = getSubtract(
          this.addGoodsList,
          this.checkedRowList,
          "supplierGoodsId"
        );
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    getBatchChecked(selection) {
      this.checkedRowList = selection;
    },
    async submit() {
      if (this.editTimeShow) {
        if (this.ruleDate.length) {
          let params = {
            rewardRuleId: this.row.rewardRuleId,
            rewardStartDate: this.ruleDate[0],
            rewardEndDate: this.ruleDate[1],
          };
          const { code } = await this.$store.dispatch(
            "editRewardRuleEndDate",
            params
          );
          if (code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.dialogVisibleTime = false;
            this.queryList();
          }
        } else {
          this.$message({
            message: "请选择时段！",
            type: "warning",
          });
        }
      } else {
        if (this.endTime !== "") {
          let params = {
            rewardRuleId: this.row.rewardRuleId,
            rewardEndDate: this.endTime,
          };
          const { code } = await this.$store.dispatch(
            "editRewardRuleEndDate",
            params
          );
          if (code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.dialogVisibleTime = false;
            this.queryList();
          }
        } else {
          this.$message({
            message: "请选择结束时间！",
            type: "warning",
          });
        }
      }
    },
    editTime(row) {
      this.row = row;
      let mydate = moment().format("YYYY/MM/DD");
      this.editTimeShow = compareDate(
        row.timeFormatValue.split("至")[0],
        mydate.replace(/\//g, "-")
      );
      this.dialogVisibleTime = true;
    },
    addChild() {
      this.ruleForm.ruleRelModelList.push({
        rewardNumberLimit: "",
        rewardValue: "",
      });
    },
    delRule(index) {
      this.ruleForm.ruleRelModelList.splice(index, 1);
    },
    importfs(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        // let importfList = [];
        that.errStoreResult = [];
        result.forEach((v) => {
          if (v[0]) {
            formatResult.push({
              storeName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
            });
          }
        });

        formatResult.forEach((v) => {
          let i = that.departBindingStoreBox.findIndex(
            (o) => o.storeName === v.storeName
          );

          if (i > -1) {
            that.shopList.push(that.departBindingStoreBox[i]);
          } else {
            that.errStoreResult.push(v);
          }
        });
        if (that.errStoreResult.length) {
          that.errValidStore = true;
        }
        that.shopList = arrayUnique2(that.shopList, "storeName");
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
      console.log("---that.shopList---", that.shopList);
    },
    async supplierGoodsInfoCheckGoods(checkGoodsList) {
      console.log(this.ruleForm);
      this.addProductPage = 1;
      this.addProductSize = 10;
      let params = {
        supplierGoodsIdList: checkGoodsList.map((v) => v.supplierGoodsId),
        applyStoreCodes: this.shopList.map((v) => v.storeCode),
        rewardStartDate: this.ruleForm.rewardStartDate,
        rewardEndDate: this.ruleForm.rewardEndDate,
      };
      const { result } = await this.$store.dispatch(
        "supplierGoodsInfoCheckGoods",
        params
      );
      if (result.length) {
        let goodsList = [];
        this.repeatGoodsDialogVisible = true;
        checkGoodsList.forEach((v) => {
          result.forEach((o) => {
            if (o.goodsBarcode === v.goodsBarcode) {
              goodsList.push(Object.assign({}, o, v));
            }
          });
        });
        this.repeatGoodsList = goodsList;
      } else {
        if (this.succInputResult && this.succInputResult.length) {
          this.succInputResult.forEach((item) => {
            if (
              !this.initTableList.find((v) => v.goodsName == item.goodsName)
            ) {
              this.initTableList.push(item);
            }
          });
        }
        this.addProductVisible = true;
      }
      let acnm = arrayUnique2(result, "supplierGoodsId");
      let subList = getSubtract(checkGoodsList, acnm, "supplierGoodsId");

      this.addGoodsList.push(...subList);
      this.addGoodsList = arrayUnique2(this.addGoodsList, "supplierGoodsId");
    },
    importfGoods(row, i) {
      this.addGoodsList.unshift(row);
      this.addGoodsList = arrayUnique2(this.addGoodsList, "supplierGoodsId");
      this.repeatGoodsList.splice(i, 1);
      if (!this.initTableList.find((v) => v.goodsName == row.goodsName)) {
        this.initTableList.push(row);
      }
    },
    allImportfGoods() {
      this.addGoodsList.unshift(...this.repeatGoodsList);
      this.addGoodsList = arrayUnique2(this.addGoodsList, "supplierGoodsId");
      this.repeatGoodsList = [];
      this.succInputResult.forEach((item) => {
        if (!this.initTableList.find((v) => v.goodsName == item.goodsName)) {
          this.initTableList.push(item);
        }
      });
      this.addProductVisible = true;
      this.repeatGoodsDialogVisible = false;
    },
    delectImportfGoods() {
      this.addGoodsList.forEach((v) => {
        this.repeatGoodsList.forEach((o) => {
          if (v.supplierGoodsId === o.supplierGoodsId) {
            v.repeat = true;
          }
        });
      });
      this.addGoodsList = this.addGoodsList.filter((item) => !item.repeat);
      this.repeatGoodsList = [];
      this.repeatGoodsDialogVisible = false;
    },
    // 导入excel
    importf(e) {
      if (!this.addGroupForm.composeName) {
        e.target.value = "";
        this.$message.warning("请输入商品组名称");
        return false;
      }
      if (!this.addGroupForm.goodsUpperLimit) {
        e.target.value = "";
        return this.$message.warning("请输入限制数量");
      }
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        let importfList = [];
        result.forEach((v) => {
          if (v[0]) {
            formatResult.push({
              goodsBarcode: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              storeCode: that.$route.query.storeCode,
            });
            if (that.ruleForm.rewardMode === "sub") {
              importfList.push({
                goodsBarcode: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
                rewardBaseMoney: v[1] ? +v[1] : "",
              });
            }
          }
        });

        console.log("---formatResult---", formatResult);

        that.$store
          .dispatch("exportRewardGoodsSupplier", formatResult)
          .then((res) => {
            const { code, result } = res;
            if (code === "0") {
              const { failList, successList } = result;
              console.log("---failListsuccessList--", failList, successList);
              if (failList.length) {
                setTimeout(() => {
                  that.errValidGoods = true;
                }, 100);
                that.errInputResult = failList;
                that.$message({
                  message: "部分条码导入失败！",
                  type: "warning",
                });
              }
              that.succInputResult = successList;

              let goodsList = [];
              // let repeatgoodsList = [];
              console.log(
                "that.ruleForm.rewardMode: ",
                that.ruleForm.rewardMode
              );
              if (that.ruleForm.rewardMode === "sub") {
                importfList.forEach((v) => {
                  v.rewardBaseMoney = v.rewardBaseMoney
                    ? v.rewardBaseMoney.toFixed(2)
                    : "";
                });
                successList.forEach((v) => {
                  importfList.forEach((o) => {
                    if (o.goodsBarcode === v.goodsBarcode) {
                      goodsList.push(Object.assign({}, o, v));
                    }
                  });
                });
              } else {
                goodsList = successList;
              }

              console.log("goodsList", this.goodsList);
              that.supplierGoodsInfoCheckGoods(goodsList);

              that.$forceUpdate();
            }
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商户名称"];
        const data = [];
        exportJsonToExcel(tHeader, data, "导入商户模板");
      });
    },
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");

        const tHeader =
          this.ruleForm.rewardMode === "sub"
            ? ["商品条码(单次最多导入200条)", "单件奖励"]
            : ["商品条码(单次最多导入200条)"];
        const data = [];
        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    changgeaa() {
      this.type = "add";
      if (this.type === "add") {
        this.value = [];
        this.shopList = [];
        this.ruleForm.applyDepartNames = [];
        this.ruleForm.applyDepartIds = [];
        this.ruleForm.applDepartId.forEach((v) => {
          this.ruleForm.applyDepartIds.push(v[v.length - 1].value);
          this.ruleForm.applyDepartNames.push(v[v.length - 1].label);
        });
      }
      if (this.ruleForm.applyDepartIds.length) {
        this.queryStoreBoxList();
      }
    },
    filterInputVal2(pKey, prop) {
      this[pKey][prop] = this[pKey][prop].replace(/^(0+)/, ""); //过滤0开头
      this[pKey][prop] = this[pKey][prop].replace(/[^\d]/g, "");
      this[pKey][prop] = this[pKey][prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
      this[pKey][prop] = this[pKey][prop] ? parseInt(this[pKey][prop]) : "";
    },
    filterInputVal(pKey, pInd, key) {
      this[pKey][pInd][key] = this[pKey][pInd][key].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this[pKey][pInd][key] = this[pKey][pInd][key].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this[pKey][pInd][key] = this[pKey][pInd][key]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this[pKey][pInd][key] = this[pKey][pInd][key].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this[pKey][pInd][key].indexOf(".") < 0 &&
        this[pKey][pInd][key] != ""
      ) {
        //首位是0的话去掉
        this[pKey][pInd][key] = parseFloat(this[pKey][pInd][key]);
      }
    },
    filterInputVal5(pKey, pInd, secondKey, cInd, key) {
      this[pKey][pInd][secondKey][cInd][key] = this[pKey][pInd][secondKey][
        cInd
      ][key].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this[pKey][pInd][secondKey][cInd][key] = this[pKey][pInd][secondKey][
        cInd
      ][key].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this[pKey][pInd][secondKey][cInd][key] = this[pKey][pInd][secondKey][
        cInd
      ][key]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this[pKey][pInd][secondKey][cInd][key] = this[pKey][pInd][secondKey][
        cInd
      ][key].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this[pKey][pInd][secondKey][cInd][key].indexOf(".") < 0 &&
        this[pKey][pInd][secondKey][cInd][key] != ""
      ) {
        //首位是0的话去掉
        this[pKey][pInd][secondKey][cInd][key] = parseFloat(
          this[pKey][pInd][secondKey][cInd][key]
        );
      }

      // 'ruleRelModelList', pInd, 'rewardValue'
      let rewardValue = 0;
      this[pKey][pInd].supplierRewardRuleGoodsComposeModelList.forEach((v) => {
        let val = v.composeAllocateReward
          ? parseFloat(v.composeAllocateReward)
          : 0;
        rewardValue += val;
      });
      console.log(rewardValue);
      this[pKey][pInd]["rewardValue"] = rewardValue.toFixed(2);
    },

    filterGt0OrListFixed0(i, prop) {
      if (prop !== "rewardSubNum") {
        this.ruleForm.ruleRelModelList[i][
          prop
        ] = this.ruleForm.ruleRelModelList[i][prop].replace(/^(0+)/, ""); //过滤0开头
      }

      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/[^\d]+/g, "");
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrListFixed2(i, prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.ruleForm.ruleRelModelList[i][prop].indexOf(".") < 0 &&
        this.ruleForm.ruleRelModelList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.ruleRelModelList[i][prop] = parseFloat(
          this.ruleForm.ruleRelModelList[i][prop]
        );
      }
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrGoodsListFixed2(i, prop) {
      this.$forceUpdate();
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.addGoodsList[i][prop].indexOf(".") < 0 &&
        this.addGoodsList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.addGoodsList[i][prop] = parseFloat(this.addGoodsList[i][prop]);
      }
    },
    filterGt0OrFixed0(prop) {
      if (prop !== "autoOfflineDaysLimt") {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      }

      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d]/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    filterGt0OrFixed00(prop) {
      if (prop === "addDays") {
        this.batchCondition[prop] = this.batchCondition[prop].replace(
          /^(0+)/,
          ""
        ); //过滤0开头
      }

      this.batchCondition[prop] = this.batchCondition[prop].replace(
        /[^\d]/g,
        ""
      );
      this.batchCondition[prop] = this.batchCondition[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    selectAll() {
      if (this.value.length < this.departBindingStoreBox.length) {
        this.value = [];
        this.departBindingStoreBox.map((item) => {
          this.value.push(`${item.storeName},${item.storeCode}`);
        });
        this.value.unshift("all");
      } else {
        this.value = [];
      }
    },
    async queryLogList() {
      let params = {
        pageSize: this.pageSizeLog,
        pageNo: this.currentPageLog,
        bizDataPk: this.row.rewardRuleId,
        bizType: "redMoneyReward",
      };
      const { result } = await this.$store.dispatch(
        "storeOperationLogList",
        params
      );
      this.logList = result.records;
      this.totalLog = result.total;
    },
    toDetails(row, index) {
      this.selectActivityIndex = index;
      this.$store
        .dispatch("detailsSupplierRewardRuleInfoList", {
          rewardRuleId: row.rewardRuleId,
        })
        .then(() => {
          this.detailsDialogVisible = true;
        });
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisibleEdit = false;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    resetRuleForm() {
      this.step = 1;
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
        this.$refs.hmDateSelect.runningTimeType = "";
        this.$refs.hmDateSelect.ruleDateAndTime = "";
        this.$refs.hmDateSelect.ruleDate = [];
        this.$refs.hmDateSelect.dateType = "";
        this.$refs.hmDateSelect.week = [];
        this.$refs.hmDateSelect.daysList = [];
      }
      if (this.$refs.ruleFormEdit) {
        this.$refs.ruleFormEdit.resetFields();
      }
      this.ruleForm.applyDepartIds = [];
      this.applDepartNames = "";
      this.ruleForm.applDepartId = [];
      this.value = "";
      this.shopList = [];
      this.addGood = {};
      this.ruleForm.rewardValue = "";
      this.ruleForm.ruleRelModelList = [
        {
          rewardNumberLimit: "",
          rewardValue: "",
        },
      ];
      this.addGoodsList = [];
    },
    pagingLog(page) {
      this.currentPageLog = page;
      this.queryLogList();
    },
    handleSizeChangeLog(size) {
      this.currentPageLog = 1;
      this.pageSizeLog = size;
      this.queryLogList();
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        supplierCode: this.$route.query.storeCode,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition[this.searchCondition.queryType] =
        searchCondition.keyWords;
      if (
        searchCondition.applyDepartIds &&
        searchCondition.applyDepartIds.length > 0
      ) {
        searchCondition.applyDepartId =
          searchCondition.applyDepartIds[
            searchCondition.applyDepartIds.length - 1
          ];
      }
      Object.assign(params, searchCondition);
      this.setParamsCookie();
      return this.$store.dispatch("querySupplierRewardRuleInfoList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "redpackageActivityListParamsNew" + this.$route.query.storeCode,
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "redpackageActivityListParamsNew" + this.$route.query.storeCode,
        type: "session",
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryStoreBoxList(query) {
      let params = {
        applyDepartIds: this.ruleForm.applyDepartIds,
        storeName: query,
        supplierCode: this.$route.query.storeCode,
      };
      return this.$store.dispatch("queryDepartBindingStoreComboBoxNew", params);
    },
    newGood() {
      this.dialogVisibleGood = true;
    },
    submitEdit(formName) {
      // editRewardRuleInfo
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.row.rewardName = this.row.rewardName
            .replace("（", "(")
            .replace("）", ")");
          let ruleRelModelList = this.ruleRelModelList.filter(
            (item) => !item.ruleRelId
          );
          let list = [];
          this.groupList.forEach((item) => {
            item.goodsComposeCollocationInfoModelList.forEach((v) => {
              if (v.hemiaoGoodsId) {
                list.push({ ...v, composeId: item.composeId });
              }
            });
          });
          //   搭配规则校验
          if (
            !this.groupList ||
            !this.groupList.length ||
            this.groupList.length < 2
          ) {
            return this.$message.warning("请至少添加两个商品组");
          }

          for (let item of this.ruleRelModelList) {
            if (!item.ruleName) {
              return this.$message.warning("请输入规则名称");
            }
            for (let goods of item.supplierRewardRuleGoodsComposeModelList) {
              console.log(goods, goods.composeName);
              if (!goods.composeName) {
                return this.$message.warning("请选择商品分组");
              }
              if (!goods.composeAllocateReward) {
                return this.$message.warning("请输入金额");
              }
            }
            // if (!item.rewardValue) {
            //   return this.$message.warning("请输入奖励红包金额");
            // }
          }
          // 判断是否有产品是相同的规则
          for (let [index, g] of this.ruleRelModelList.entries()) {
            let ruleGoodsInfo = g.supplierRewardRuleGoodsComposeModelList;
            let list = this.ruleRelModelList.slice(
              index + 1,
              this.groupList.length
            );

            for (let li of list) {
              ruleGoodsInfo.length ===
                li.supplierRewardRuleGoodsComposeModelList.length;
              // composeName
              // 两个规则的产品分组数相同时，判断产品组是否相同
              if (
                ruleGoodsInfo.length ===
                li.supplierRewardRuleGoodsComposeModelList.length
              ) {
                let isSame = true;
                li.supplierRewardRuleGoodsComposeModelList.forEach((v) => {
                  if (isSame == true) {
                    isSame = ruleGoodsInfo.some(
                      (item) => item.composeName === v.composeName
                    );
                  }
                });
                if (isSame) {
                  return this.$message.warning("不同规则的商品分组不能重复");
                }
              }
            }
          }
          let params = {
            rewardRuleId: this.row.rewardRuleId,
            rewardName: this.row.rewardName,
            autoOfflineDaysLimt: this.ruleFormEdit.autoOfflineDaysLimt,
            storeBasicInfoModelList: this.shopList,
            // ruleGoodsList: this.addGoodsList,
            ruleGoodsList: list,
            ruleRelModelList,
          };

          let list2 = [];
          this.ruleRelModelList.forEach((item) => {
            list2 = list2.concat(item.supplierRewardRuleGoodsComposeModelList);
          });
          let arr = [];
          this.groupList.forEach((v) => {
            let find = list2.find((item) => item.composeName === v.composeName);
            if (!find) {
              arr.push(v.composeName);
            }
          });
          if (arr.length) {
            console.log(arr.join(","));
            const h = this.$createElement;
            this.$msgbox({
              title: "提示",
              message: h("p", null, [
                h("span", null, "商品组 "),
                h(
                  "span",
                  { style: "color: blue", margin: "0 10px" },
                  arr.join(",")
                ),
                h("span", null, "未被使用将不会被保存"),
              ]),
              showCancelButton: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  this.$store
                    .dispatch("updateSupplierRewardRuleInfoCollocation", params)
                    .then((res) => {
                      if (res.code === "0") {
                        this.$message({
                          message: "操作成功",
                          type: "success",
                        });
                        this.$router.push({
                          name: "MatchActivityManagement",
                          query: {
                            storeCode: this.$route.query.storeCode,
                          },
                        });
                      }
                    });
                  done();
                } else {
                  done();
                }
              },
            });
          } else {
            this.$store
              .dispatch("updateSupplierRewardRuleInfoCollocation", params)
              .then((res) => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.$router.push({
                    name: "MatchActivityManagement",
                    query: {
                      storeCode: this.$route.query.storeCode,
                    },
                  });
                }
              });
          }
        }
      });
    },
    submitRuleForm(formName) {
      if (this.step === 1) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (
              !this.ruleForm.ruleRelModelList ||
              this.ruleForm.ruleRelModelList.length < 1
            ) {
              this.$message({
                message: "请填写活动规则!",
                type: "warning",
              });
              return false;
            }
            const {
              runningTimeType,
              ruleDateAndTime,
              ruleDate,
              dateType,
              dateValue,
              // dateConfigRange,
              week,
              daysList,
            } = this.$refs.hmDateSelect;
            console.log("---dateValue---", dateValue);
            let step1 = {};
            step1.dateConfigMode =
              runningTimeType === "all" ? "general" : "special";
            if (runningTimeType === "all") {
              // 选择全时段
              step1.rewardStartDate = ruleDateAndTime.length
                ? ruleDateAndTime[0]
                : "";
              step1.rewardEndDate = ruleDateAndTime.length
                ? ruleDateAndTime[1]
                : "";
            } else if (runningTimeType === "special") {
              // 选择特定时段
              // step1.dateConfigRange = dateConfigRange.sort(
              //   this.sortTime("promotionStartTime")
              // );
              step1.rewardStartDate = ruleDate[0];
              step1.rewardEndDate = ruleDate[1];
              step1.dateType = dateType === "day" ? "date" : dateType;
              if (dateType === "day") {
                step1.dateValue = dateValue.sort();
              } else if (dateType === "week") {
                step1.dateValue = week.sort();
              } else if (dateType === "month") {
                step1.dateValue = daysList;
              }
            }
            if (this.type === "add") {
              this.ruleForm.applyDepartNames = [];
              this.ruleForm.applyDepartIds = [];
              this.ruleForm.applDepartId.forEach((v) => {
                this.ruleForm.applyDepartIds.push(v[v.length - 1].value);
                this.ruleForm.applyDepartNames.push(v[v.length - 1].label);
              });
            }
            this.ruleForm.ruleRelModelList.forEach((v) => {
              v.rewardNumberLimit = new Number(v.rewardNumberLimit);
              if (this.ruleForm.rewardMode === "sub") {
                v.rewardSubNum = new Number(v.rewardSubNum);
              }
            });
            this.ruleForm.autoOfflineDaysLimt = new Number(
              this.ruleForm.autoOfflineDaysLimt
            );
            Object.assign(this.ruleForm, step1);
            this.step = this.step + 1;
          } else {
            return false;
          }
        });
      } else if (this.step === 2) {
        if (this.shopList.length > 0) {
          this.step = this.step + 1;
          this.queryMicroShopGoodsList();
          // if (this.type == "copy") {
          //   this.supplierGoodsInfoCheckGoods(this.addGoodsList);
          // }
        } else {
          this.$message({
            message: "请添加商户!",
            type: "warning",
          });
        }
      } else if (this.step === 3) {
        if (
          !this.groupList ||
          !this.groupList.length ||
          this.groupList.length < 2
        ) {
          return this.$message.warning("请至少添加两个商品组");
        }

        for (let item of this.ruleRelModelList) {
          if (!item.ruleName) {
            return this.$message.warning("请输入规则名称");
          }
          for (let goods of item.supplierRewardRuleGoodsComposeModelList) {
            console.log(goods, goods.composeName);
            if (!goods.composeName) {
              return this.$message.warning("请选择商品分组");
            }
            if (!goods.composeAllocateReward) {
              return this.$message.warning("请输入金额");
            }
          }
          // if (!item.rewardValue) {
          //   return this.$message.warning("请输入奖励红包金额");
          // }
        }

        // 判断是否有产品是相同的规则
        for (let [index, g] of this.ruleRelModelList.entries()) {
          let ruleGoodsInfo = g.supplierRewardRuleGoodsComposeModelList;
          let list = this.ruleRelModelList.slice(
            index + 1,
            this.groupList.length
          );

          for (let li of list) {
            ruleGoodsInfo.length ===
              li.supplierRewardRuleGoodsComposeModelList.length;
            // composeName
            // 两个规则的产品分组数相同时，判断产品组是否相同
            if (
              ruleGoodsInfo.length ===
              li.supplierRewardRuleGoodsComposeModelList.length
            ) {
              let isSame = true;
              li.supplierRewardRuleGoodsComposeModelList.forEach((v) => {
                if (isSame == true) {
                  isSame = ruleGoodsInfo.some(
                    (item) => item.composeName === v.composeName
                  );
                }
              });
              if (isSame) {
                return this.$message.warning("不同规则的商品分组不能重复");
              }
            }
          }
        }
        this.step = this.step + 1;
      } else if (this.step === 4) {
        let params = {};
        params.applyStoreCodes = this.shopList.map((v) => v.storeCode);
        params.ruleGoodsList = this.addGoodsList;
        params.supplierCode = this.$route.query.storeCode;
        this.ruleForm.rewardName = this.ruleForm.rewardName
          .replace("（", "(")
          .replace("）", ")");
        Object.assign(params, this.ruleForm, {
          ruleRelModelList: this.ruleRelModelList,
        });
        console.log(params);
        let list = [];
        this.ruleRelModelList.forEach((item) => {
          list = list.concat(item.supplierRewardRuleGoodsComposeModelList);
        });
        let arr = [];
        this.groupList.forEach((v) => {
          let find = list.find((item) => item.composeName === v.composeName);
          if (!find) {
            arr.push(v.composeName);
          }
        });
        if (arr.length) {
          const h = this.$createElement;
          this.$msgbox({
            title: "提示",
            message: h("p", null, [
              h("span", null, "商品组 "),
              h(
                "span",
                { style: "color: blue", margin: "0 10px" },
                arr.join(",")
              ),
              h("span", null, "未被使用将不会被保存"),
            ]),
            showCancelButton: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                this.$store
                  .dispatch("saveSupplierRewardRuleInfoCollocation", params)
                  .then((res) => {
                    if (res.code === "0") {
                      this.$message({
                        message: "操作成功",
                        type: "success",
                      });
                      done();
                      this.$router.push({
                        name: "MatchActivityManagement",
                        query: {
                          storeCode: this.$route.query.storeCode,
                        },
                      });
                    }
                  });
              } else {
                done();
              }
            },
          });
        } else {
          this.$store
            .dispatch("saveSupplierRewardRuleInfoCollocation", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.push({
                  name: "MatchActivityManagement",
                  query: {
                    storeCode: this.$route.query.storeCode,
                  },
                });
              }
            });
        }
      }
    },
    sortTime(property) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return (
          new Date(new Date().toLocaleDateString() + " " + value1).getTime() -
          new Date(new Date().toLocaleDateString() + " " + value2).getTime()
        );
      };
    },
    swithRunningTimeType() {
      this.$refs.validatorTime.clearValidate();
    },
    getChecked(selection) {
      this.checkedRow = selection;
      this.$set(this.checkedList, this.currentMicroPage, selection);
      // this.checkedRow = selection.map(v => v.spuId);
    },
    addShop() {
      const list = this.checkedMerchantRow;
      let json = this.shopList.concat(list);
      let newJson = [];
      for (let item1 of json) {
        let flag = true;
        for (let item2 of newJson) {
          if (item1.storeCode == item2.storeCode) {
            flag = false;
          }
        }
        if (flag) {
          newJson.push(item1);
        }
      }
      this.shopList = newJson;
      // this.shopList.map(v => {
      //   if (v.storeCode === this.value) {
      //     show = true;
      //   }
      // });
      // if (!show) {
      //   this.shopList.push({
      //     storeName: this.$refs.selectCh.selectedLabel,
      //     storeCode: this.value
      //   });
      // }
      // this.value = "";
      this.merchantDialogVisible = false;
    },
    remove(row) {
      let list = [];
      list.push(row);
      this.shopList = getSubtract(this.shopList, list, "storeCode");
    },
    addGoods() {
      this.dialogVisibleGoods = true;
      // this.queryMicroShopGoodsList();
      this.$store.dispatch("queryHemiaoBrandComboBox", {
        supplierCode: this.$route.query.storeCode,
      });
    },
    searchGoods() {
      this.currentMicroPage = 1;
      this.queryMicroShopGoodsList();
    },
    getMerchantChecked(selection) {
      this.checkedMerchantRow = selection;
    },
    batchSetting() {
      if (!this.batchCondition.endTime && !this.batchCondition.addDays) {
        this.$message({
          message: "请选择结束时间或者请选择活动下线天数",
          type: "warning",
        });
        return;
      }
      let say = "修改已选" + this.checkedDelRow.length + "条数据的结束时间";
      this.$confirm(say, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        let params = {};
        if (this.batchCondition.endTime) {
          params = {
            rewardEndDate: this.batchCondition.endTime,
            rewardRuleIds: this.checkedDelRow,
            // supplierCode: this.$route.query.storeCode,
          };
          console.log("活动结束时间params:", params);
          this.$store
            .dispatch("editRewardRuleEndDateBatch", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });
                this.batchCondition.endTime = "";
                this.dialogVisibleTimeBatch = false;
                this.queryList();
              }
            });
        }
        if (this.batchCondition.addDays) {
          params = {
            rewardRuleIdList: this.checkedDelRow,
            addDays: this.batchCondition.addDays,
            // supplierCode: this.$route.query.storeCode,
          };
          console.log("活动下线天数params:", params);
          this.$store
            .dispatch("batchIncreaseAutoOfflineDaysLimt", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });
                this.batchCondition.endTime = "";
                this.dialogVisibleTimeBatch = false;
                this.queryList();
              }
            });
        }
      });
    },
    editAddGoods() {
      this.dialogVisibleGoods = true;
      this.currentMicroPage = 1;
      this.pageMicroSize = 10;
      this.queryMicroShopGoodsList();
    },
    pagingMicro(page, ref = null) {
      this.currentMicroPage = page;
      this.queryMicroShopGoodsList();
      if (ref) {
        const list = this.checkedList[page];
        // console.log(this.$refs[ref])
        // console.log('list--', list);
        this.$nextTick(() => {
          list &&
            list.forEach((row) => {
              this.$refs[ref].toggleRowSelection(row);
            });
        });
      }
    },
    handleSizeMicroChange(size) {
      this.currentMicroPage = 1;
      this.pageMicroSize = size;
      this.queryMicroShopGoodsList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryMicroShopGoodsList() {
      let params = {
        pageSize: this.pageMicroSize,
        pageNo: this.currentMicroPage,
        storeCode: this.$route.query.storeCode,
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );

      Object.assign(params, searchDialogCondition);

      return this.$store.dispatch("querySupplierGoodsInfoList", params);
    },
    affirm() {
      if (this.checkedRow.length) {
        this.supplierGoodsInfoCheckGoods(this.checkedRow);
        // supplierGoodsInfoCheckGoods
        console.log("this.addGoodsList: ", this.addGoodsList);
        this.dialogVisibleGoods = false;
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning",
        });
      }
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.ruleFormGood;
          params.storeCode = this.$route.query.storeCode;
          return this.$store
            .dispatch("saveSupplierGoodsInfoList", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });

                this.queryMicroShopGoodsList();
                this.dialogVisibleGood = false;
              }
            });
        } else {
          return false;
        }
      });
    },
    removeGoods(row) {
      let list = [];
      list.push(row);
      this.addGoodsList = getSubtract(
        this.addGoodsList,
        list,
        "supplierGoodsId"
      );
      /*this.addGoodsList.splice(index, 1);*/
    },
    filterGt0OrGoodsListFixed2(i, prop) {
      this.$forceUpdate();
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.addGoodsList[i][prop].indexOf(".") < 0 &&
        this.addGoodsList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.addGoodsList[i][prop] = parseFloat(this.addGoodsList[i][prop]);
      }
    },
    /**
     * @desc 添加商品组
     */
    handleAddGroup(item) {
      let seqNum = item.supplierRewardRuleGoodsComposeModelList.slice(-1)[0]
        .seqNum;
      item.supplierRewardRuleGoodsComposeModelList.push({
        seqNum: seqNum + 1,
      });
      //   this.$store.dispatch("queryHemiaoBrandComboBox", {
      //     supplierCode: this.$route.query.storeCode,
      //   });
    },
    /**
     * @desc 删除组
     */
    handleDeleteGroup(item, pInd) {
      this.ruleRelModelList.splice(pInd, 1);
    },
    handleCloseGroup(pInd, cInd) {
      this.ruleRelModelList[
        pInd
      ].supplierRewardRuleGoodsComposeModelList.splice(cInd, 1);
    },
    handleAddGroupList(item, type, index = null) {
      console.log("22222", item);
      this.editInd = index;
      this.initTableList = [];
      if (item) {
        this.addGroupForm = {
          composeName: item.composeName,
          goodsUpperLimit: item.goodsUpperLimit,
        };
        this.checkedRow = item.goodsComposeCollocationInfoModelList;
      }
      this.disabledAddGroup = type == "detail" || type == "edit";
      this.forbidden = type == "detail";
      if (type === "detail" || type === "edit") {
        this.currentListIndex = index;
        this.initTableList = JSON.parse(
          JSON.stringify(item.goodsComposeCollocationInfoModelList)
        );
        // this.is
        if (type === "detail") {
          this.addProductVisible = true;
          return;
        }
      }

      this.addGroupDialogVisible = true;
      this.$store.dispatch("queryHemiaoBrandComboBox", {
        supplierCode: this.$route.query.storeCode,
      });
    },
    handleAddGroupSubmit() {
  try {
    // 校验表单有效性
    this.$refs.addGroupForm.validate((valid) => {
      if (typeof valid !== 'boolean') {
        throw new Error('表单验证结果类型不正确');
      }

      if (!valid) return;

      // 检查 checkedRow 是否为合法数组且非空
      if (!Array.isArray(this.checkedRow) || !this.checkedRow.length) {
        return this.$message.warning("请最少添加一件商品");
      }

      // 设置成功输入结果并调用供应商商品检查方法
      this.succInputResult = this.checkedRow;
      this.supplierGoodsInfoCheckGoods(this.checkedRow);

      // 清理注释掉的代码，保留核心逻辑
    });

    // 移除调试代码
    // console.log(this.$refs.addGoodGroupTable);
    // console.log(this.checkedRow);
    // console.log(this.addGroupForm);

  } catch (error) {
    console.error("提交分组时发生错误：", error.message);
    this.$message.error("系统异常，请稍后再试");
  }
},

    /**
     * @desc 添加搭配规则
     */
    handleAddMatchRule() {
      // const item = this.matchRules[this.matchRules.length - 1]
      // this.matchRules.push({
      //     list: [{seqNum: 0}, {seqNum: 1}],
      //     rewardBaseMoney: "",
      //     seqNum: item?(item.seqNum + 1): 0
      // });

      const item = this.ruleRelModelList[this.ruleRelModelList.length - 1];
      this.ruleRelModelList.push({
        supplierRewardRuleGoodsComposeModelList: [
          {
            seqNum: 0,
            composeName: "",
            goodsUpperLimit: "",
            ruleGoodsList: [],
            id: "",
          },
          {
            seqNum: 1,
            composeName: "",
            goodsUpperLimit: "",
            ruleGoodsList: [],
            id: "",
          },
        ],
        rewardValue: "",
        seqNum: item && item.seqNum ? item.seqNum + 1 : 0,
      });
    },
    /**
     * @desc 删除商品
     */
    handleDelProduct(scope) {
      console.log(scope);
      this.initTableList.splice(scope.$index, 1);
      this.setPageNum();
    },
  
    batchDelProductsChange(selection) {
      console.log(selection,777777)
    },
    /**
     * @desc 批量删除
     */
    batchDelProducts() {
      console.log(this.$refs.addProductTable.selection);
      const selection = this.$refs.addProductTable.selection;
      this.initTableList = this.initTableList.filter((item) => {
        if (
          !selection.some(
            (s) => s.goodsBarcode == item.goodsBarcode
          )
        ) {
          return item;
        }
      });
      this.setPageNum();
    },
    // setPageNum() {
    //   let num = this.initTableList.length / this.addProductSize;
    //   let n = parseInt(this.initTableList.length / this.addProductSize);
    //   if (n < num) {
    //     this.addProductPage = n + 1;
    //   } else {
    //     this.addProductPage = n;
    //   }
    // },
setPageNum() {
    // 校验输入是否合法
    if (typeof this.addProductSize !== 'number' || this.addProductSize <= 0) {
        console.error('addProductSize 必须是一个大于 0 的数字');
        return;
    }

    // 计算页数，使用 Math.ceil 简化逻辑
    const totalPages = Math.ceil(this.initTableList.length / this.addProductSize);

    // 检查当前页是否有数据
    const currentPageHasData = this.initTableList.slice(
        (this.addProductPage - 1) * this.addProductSize,
        this.addProductPage * this.addProductSize
    ).length > 0;

    // 如果当前页没有数据且当前页大于1，则将当前页减1
    if (!currentPageHasData && this.addProductPage > 1) {
        this.addProductPage -= 1;
    }

    // 设置页数
    this.addProductPage = Math.min(this.addProductPage, totalPages) || 0; // 如果列表为空，页数应为 0

    // 调试日志
    console.log(`当前列表长度: ${this.initTableList.length}, 每页大小: ${this.addProductSize}, 总页数: ${totalPages}, 当前页: ${this.addProductPage}`);
},
    getGroupOptions(group) {
      let li = [];
      group.list.forEach((item) => {});
      // groupList.filter(item => )
    },
    changeProductGroup($event, pInd, cInd) {
      console.log($event, pInd, cInd);
      const item = this.groupList.find((item) => item.composeName == $event);
      console.log("-----item----", this.groupList, item);
      // this.matchRules[pInd].ruleGoodsList = item.list
      // this.matchRules.composeName = item.composeName
      // this.matchRules.goodsUpperLimit = item.goodsUpperLimit
      this.ruleRelModelList[pInd]["supplierRewardRuleGoodsComposeModelList"][
        cInd
      ].id =
        item.composeId;
      this.ruleRelModelList[pInd]["supplierRewardRuleGoodsComposeModelList"][
        cInd
      ].composeName =
        item.composeName;
      this.ruleRelModelList[pInd]["supplierRewardRuleGoodsComposeModelList"][
        cInd
      ].goodsUpperLimit =
        item.goodsUpperLimit;
      this.ruleRelModelList[pInd]["supplierRewardRuleGoodsComposeModelList"][
        cInd
      ].ruleGoodsList =
        item.goodsComposeCollocationInfoModelList;
    },
    handleBack() {
      history.go(-1);
    },
    handleAudit(type) {
      this.$store
        .dispatch("auditSupplierRewardRuleInfo", {
          auditState: type,
          rewardRuleId: this.row.rewardRuleId,
          supplierCode: this.$route.query.storeCode,
        })
        .then((res) => {
          if (res.code === "0") {
            this.$message.success("操作成功");
            this.$router.push({
              name: "MatchActivityManagement",
              query: {
                storeCode: this.$route.query.storeCode,
              },
            });
          }
        });
    },
  },
};
</script>
<style lang="scss">
.applDepart {
  width: 600px;

  .el-input {
    width: 600px;

    input {
      width: 600px;
    }
  }
}
</style>
<style lang="scss" scoped>
.add-match-activity-management {
  min-height: calc(100vh - 165px);
  .error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
  }

  .title {
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(34, 34, 34, 1);
  }

  /deep/ .activity-style {
    background-color: #fce6f0 !important;
  }
  .step-item-wrap {
    background: #fff;
    min-height: calc(100% - 85px);
    padding: 30px 30px 10px;
    box-sizing: border-box;
    .step-title {
      height: 20px;
      font-size: 14px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      color: #222222;
      line-height: 16px;
      margin-bottom: 20px;
      position: relative;
      &::before {
        content: "";
        display: inline-block;
        width: 3px;
        height: 14px;
        background: #e50065;
        border-radius: 2px 0px 2px 0px;
        vertical-align: middle;
        margin-right: 10px;
      }
    }
    // /deep/
    .step3-wrap {
      .content_wrap {
        padding: 30px 30px 10px;
        display: flex;
        flex-direction: column;
        border-radius: 4px 4px 4px 4px;
        background: #f4f4f4;
        /deep/ .el-select,
        .el-input,
        .el-input__inner {
          height: 56px;
        }
        /deep/ .el-input__inner {
          height: 56px;
        }
        /deep/ .el-input__prefix {
          width: 96px;
          height: calc(100% - 2px);
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f4f4f4;
          color: #222222;
          left: 1px;
          top: 1px;
          border-radius: 4px 0px 0px 4px;
          border-right: 1px solid #dcdfe6;
          // border-radius: 8px 0px 0px 8px;
        }
        /deep/ .el-input--prefix .el-input__inner {
          padding-left: 112px;
        }
        .group-wrap {
          div {
            flex-shrink: 0;
          }
          .group-item-wrap {
            padding: 20px 20px 0;
            background: #fff;
            /deep/ {
              .el-input-group__prepend {
                background: #f4f4f4;
                color: #222222;
              }
            }
          }
          .group-item {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 20px;
            .group-add-item {
              position: relative;
              display: flex;
              align-items: center;
              .add-icon {
                width: 30px;
                height: 30px;
                background: #686868;
                border-radius: 50%;
                font-size: 40px;
                color: #fff;
                margin: 0 19px;
                // font-weight: 600;
              }
              .close-item {
                position: absolute;
                right: -17px;
                top: -20px;
                cursor: pointer;
                padding: 10px;
              }
              /deep/ {
                .el-select {
                  .el-input__inner {
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                  }
                }
              }
            }

            .add-btn {
              width: 54px;
              height: 54px;
              margin-left: 19px;
              border-radius: 8px 8px 8px 8px;
              opacity: 1;
              border: 1px dashed #e50065;
              font-size: 40px;
              color: #e50065;
              cursor: pointer;
            }

            .equal {
              width: 30px;
              height: 30px;
              background: #686868;
              border-radius: 50%;
              font-size: 40px;
              color: #fff;
              margin: 0 19px;
            }

            .rewardBaseMoney {
            }
          }
        }
        .add-btn {
          align-self: flex-start;
        }
      }
      .require {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        .icon {
          &::before {
            content: "*";
            display: inline-block;
            color: #ff0000;
          }
        }
      }
      .tips-icon {
        width: 14px;
        height: 14px;
        background: #808080;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-left: 4px;
        color: #fff;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
      }

      .step-item-wrap {
        display: flex;
        background: #f4f4f4;
        padding: 0;
        div {
          flex-shrink: 0;
          box-sizing: border-box;
        }
        .add-btn-wrap {
          width: 320px;
          height: 368px;
          background: #ffffff;
          border-radius: 6px 6px 6px 6px;
          border: 1px solid #dddddd;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: #999999;
          cursor: pointer;
          .add-icon {
            width: 30px;
            height: 30px;
            line-height: 25px;
            background: #e50065;
            border-radius: 16px 16px 16px 16px;
            font-size: 32px;
            font-weight: 400;
            color: #fdfdfd;
            margin-bottom: 12px;
            text-align: center;
          }
        }
        .add-group {
          flex: 1;
          overflow-x: auto;
          display: flex;
          flex-wrap: nowrap;
          margin-left: 20px;
          padding-bottom: 18px;
          background: #f4f4f4;
          &::-webkit-scrollbar {
            height: 6px;
            border-radius: 4px 4px 4px 4px;
          }
          &::-webkit-scrollbar-thumb {
            background: #dddddd;
            border-radius: 4px 4px 4px 4px;
          }
          .add-wrap {
            width: 545px;
            height: 366px;
            padding: 20px;
            background: #fff;
            margin-right: 20px;
            border-radius: 6px 6px 6px 6px;
            &:last-of-type {
              margin-right: 0;
            }
            .header {
              height: 20px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              color: #222222;
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 10px;
              span {
              }
            }

            .footer {
              display: flex;
              justify-content: space-between;
              el-button {
              }
            }
          }
        }
      }
    }
  }
  /deep/ .step {
    padding: 9px 52px;
  }
}
.btn-wrapper {
  padding: 10px 0;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-wrap {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .left {
    .el-input {
      margin-right: 10px;
    }

    .el-button {
      margin-left: 20px;
    }
  }

  .right {
    display: flex;
    .import {
      margin-right: 20px;
      cursor: pointer;
    }
  }
}
.page-wrap {
  position: relative;
  text-align: center;
  .delete-some {
    position: absolute;
    left: 0;
  }
}
.mt5 {
  margin-top: 5px;
}
.reward {
  width: 120px !important;
  /deep/ {
    // .el-input__inner,
    // .el-input-group__prepend {
    //   padding: 0 !important;
    //   border-left: unset;
    // }
    .el-input__prefix {
      width: 58px !important;
      padding: 0 !important;
      background: #fff;
      text-align: center;
      border-radius: 0;
      border-right: unset;
      border-left: unset;
    }
    .el-input__inner {
      padding-left: 64px !important;
      padding-right: 10px;
      border-top-left-radius: unset;
      border-bottom-left-radius: unset;
    }
  }
}
</style>
